class ProductCustomizer {
  constructor(root) {
    this.forcedAddonVariantId = 53714278809937;
    this.root = root;
    this.formId = root.dataset.formId;
    this.form = document.getElementById(this.formId);
    this.types = this.parseLines(root.dataset.typesRaw);
    this.productOptions = this.parseJsonScript("[data-customizer-product-options]", []);
    this.productVariants = this.parseJsonScript("[data-customizer-product-variants]", []);
    this.variantWorldCupColors = this.parseJsonScript("[data-customizer-variant-world-cup-colors]", {});
    this.variantZoneImages = this.parseJsonScript("[data-customizer-variant-zone-images]", {});
    this.worldCupConfig = this.parseJsonScript("[data-customizer-world-cup-config]", { countries: [], layouts: {} });
    this.productZoneKeys = this.parseProductZoneKeys(root.dataset.productZoneKeys);
    this.zonesVinyl = this.parseZones(root.dataset.zonesRaw);
    this.zonesBordado = this.parseZones(root.dataset.zonesRawBordado);
    this.zonesVinyl = this.filterZonesForProduct(this.zonesVinyl);
    this.zonesBordado = this.filterZonesForProduct(this.zonesBordado);
    this.zones = this.zonesVinyl;
    this.vinylColors = this.parseColors(root.dataset.vinylColorsRaw);
    this.garmentColors = this.parseColors(root.dataset.garmentColorsRaw);
    this.baseImageUrl = root.dataset.baseImage;
    this.initialBaseImageUrl = this.baseImageUrl;
    this.baseImageDefaultUrl = this.baseImageUrl;
    this.currentVariant = this.parseCurrentVariant();
    this.worldCupMode = String(root.dataset.worldCupMode || "").toLowerCase() === "true";
    this.colorOptionIndex = root.dataset.colorOptionIndex === "" ? -1 : Number(root.dataset.colorOptionIndex);
    this.syncGarmentColorFromVariant = true;
    this.showIntegratedVariantPicker = root.dataset.showIntegratedVariantPicker === "true";
    this.variantPickerColorStyle = root.dataset.variantPickerColorStyle || "image";
    this.variantLabels = {
      manga: root.dataset.labelManga || "Manga",
      color: root.dataset.labelColor || "Color",
      talla: root.dataset.labelTalla || "Talla",
      talla_papa: root.dataset.labelTallaPapa || "Talla Papá",
      talla_mama: root.dataset.labelTallaMama || "Talla Mamá",
      talla_bebe: root.dataset.labelTallaBebe || "Talla Bebé",
      talla_nino: root.dataset.labelTallaNino || "Talla Niño"
    };
    this.variantOptionVisibility = {
      manga: root.dataset.showOptionManga !== "false",
      color: root.dataset.showOptionColor !== "false",
      talla: root.dataset.showOptionTalla !== "false",
      talla_papa: root.dataset.showOptionTallaPapa !== "false",
      talla_mama: root.dataset.showOptionTallaMama !== "false",
      talla_bebe: root.dataset.showOptionTallaBebe !== "false",
      talla_nino: root.dataset.showOptionTallaNino !== "false"
    };
    this.variantOptionVisibilityMode = {
      manga: root.dataset.visibilityOptionManga || "start",
      color: root.dataset.visibilityOptionColor || "start",
      talla: root.dataset.visibilityOptionTalla || "start",
      talla_papa: root.dataset.visibilityOptionTallaPapa || "start",
      talla_mama: root.dataset.visibilityOptionTallaMama || "start",
      talla_bebe: root.dataset.visibilityOptionTallaBebe || "start",
      talla_nino: root.dataset.visibilityOptionTallaNino || "start"
    };
    this.variantOptionOrder = {
      manga: Number(root.dataset.orderManga || 1),
      color: Number(root.dataset.orderColor || 2),
      talla: Number(root.dataset.orderTalla || 3),
      talla_papa: Number(root.dataset.orderTallaPapa || 4),
      talla_mama: Number(root.dataset.orderTallaMama || 5),
      talla_bebe: Number(root.dataset.orderTallaBebe || 6),
      talla_nino: Number(root.dataset.orderTallaNino || 7)
    };
    this.nameLabel = root.dataset.labelName || "Nombre";
    this.numberLabel = root.dataset.labelNumber || "Número";
    this.yearDadLabel = root.dataset.labelYearDad || "Año Papa";
    this.yearBabyLabel = root.dataset.labelYearBaby || "Año Bebe";
    this.yearMomLabel = root.dataset.labelYearMom || "Año Mama";
    this.playerNameLabel = root.dataset.labelPlayerName || "Nombre Jugador";
    this.dadNameLabel = root.dataset.labelDadName || "Nombre Papá";
    this.momNameLabel = root.dataset.labelMomName || "Nombre Mamá";
    this.childNameLabel = root.dataset.labelChildName || "Nombre Hijo";
    this.dadNumberLabel = root.dataset.labelDadNumber || "Número Papá";
    this.momNumberLabel = root.dataset.labelMomNumber || "Número Mamá";
    this.childNumberLabel = root.dataset.labelChildNumber || "Número Hijo";
    this.baseImageCache = new Map();
    this.requireDesign = root.dataset.requireDesign === "true";
    this.requireType = root.dataset.requireType === "true";
    this.requireZone = root.dataset.requireZone === "true";
    this.requireVinylColor = root.dataset.requireVinylColor === "true";
    this.requireGarmentColor = root.dataset.requireGarmentColor === "true";
    this.requireFlag = root.dataset.requireFlag === "true";
    this.requireName = root.dataset.requireName === "true";
    this.requireNumber = root.dataset.requireNumber === "true";
    this.requireOptionManga = root.dataset.requireOptionManga === "true";
    this.requireOptionColor = root.dataset.requireOptionColor === "true";
    this.requireOptionTalla = root.dataset.requireOptionTalla === "true";
    this.requireYearDad = root.dataset.requireYearDad === "true";
    this.requireYearBaby = root.dataset.requireYearBaby === "true";
    this.requireYearMom = root.dataset.requireYearMom === "true";
    this.requirePlayerName = root.dataset.requirePlayerName === "true";
    this.requireDadName = root.dataset.requireDadName === "true";
    this.requireMomName = root.dataset.requireMomName === "true";
    this.requireChildName = root.dataset.requireChildName === "true";
    this.requireDadNumber = root.dataset.requireDadNumber === "true";
    this.requireMomNumber = root.dataset.requireMomNumber === "true";
    this.requireChildNumber = root.dataset.requireChildNumber === "true";
    this.forceFullZone = root.dataset.forceFullZone === "true";
    this.vinylLabel = root.dataset.vinylLabel || "Vinilo";
    this.bordadoLabel = root.dataset.bordadoLabel || "Bordado";
    this.visibilityZone = root.dataset.visibilityZone || "start";
    this.visibilityType = root.dataset.visibilityType || "start";
    this.visibilityVinyl = root.dataset.visibilityVinyl || "zone";
    this.visibilityGarment = root.dataset.visibilityGarment || "start";
    this.visibilityFlag = root.dataset.visibilityFlag || "zone";
    this.visibilityName = root.dataset.visibilityName || "zone";
    this.visibilityNumber = root.dataset.visibilityNumber || "zone";
    this.visibilityYearDad = root.dataset.visibilityYearDad || "zone";
    this.visibilityYearBaby = root.dataset.visibilityYearBaby || "zone";
    this.visibilityYearMom = root.dataset.visibilityYearMom || "zone";
    this.visibilityPlayerName = root.dataset.visibilityPlayerName || "zone";
    this.visibilityDadName = root.dataset.visibilityDadName || "zone";
    this.visibilityMomName = root.dataset.visibilityMomName || "zone";
    this.visibilityChildName = root.dataset.visibilityChildName || "zone";
    this.visibilityDadNumber = root.dataset.visibilityDadNumber || "zone";
    this.visibilityMomNumber = root.dataset.visibilityMomNumber || "zone";
    this.visibilityChildNumber = root.dataset.visibilityChildNumber || "zone";
    this.visibilityEditor = root.dataset.visibilityEditor || "zone";
    this.chargePersonalizationFee = root.dataset.chargePersonalizationFee !== "false";
    this.enablePriceIncrement = root.dataset.enablePriceIncrement === "true";
    this.enableMultiZoneSurcharge = root.dataset.enableMultiZoneSurcharge === "true";
    this.multiZoneSurchargeThreshold = Math.max(2, Number(root.dataset.multiZoneSurchargeThreshold || 2));
    this.multiZoneSurchargeAmount = Math.max(0, this.parsePrice(root.dataset.multiZoneSurchargeAmount || "5,00"));
    this.normalizeZonePricingMode();
    this.addonHandle = root.dataset.addonHandle || "personalizacion";
    this.addonVariantId = root.dataset.addonVariantId ? Number(root.dataset.addonVariantId) : null;
    this.addonProduct = null;
    this.addonSyncing = false;
    this.zonesSelected = new Map();
    this.currentZone = null;
    this.fontLoadPromise = null;

    this.state = {
      type: "",
      vinylColor: "",
      garmentColor: "",
      flag: false,
      name: "",
      number: "",
      yearDad: "",
      yearBaby: "",
      yearMom: "",
      playerName: "",
      dadName: "",
      momName: "",
      childName: "",
      dadNumber: "",
      momNumber: "",
      childNumber: "",
      text: "",
      textColor: "#111111",
      textFont: "sans-serif",
      textSize: 28,
      textPos: { x: 0.5, y: 0.5 },
      textScale: { x: 1, y: 1 },
      zoneArea: null
    };

    this.canvas = root.querySelector("[data-customizer-canvas]");
    this.ctx = this.canvas.getContext("2d");
    this.errorsEl = root.querySelector("[data-customizer-errors]");
    this.editorEl = root.querySelector("[data-customizer-editor]");
    this.editorOverlayEl = root.querySelector("[data-customizer-editor-overlay]");
    this.variantPickerEl = root.querySelector("[data-customizer-variant-picker]");
    this.zoneFieldEl = root.querySelector("[data-customizer-zone-field]");
    this.zoneSummaryEl = root.querySelector("[data-customizer-zone-summary]");
    this.vinylFieldEl = root.querySelector("[data-customizer-vinyl-field]");
    this.garmentFieldEl = root.querySelector("[data-customizer-garment-field]");
    this.flagFieldEl = root.querySelector("[data-customizer-flag-field]");
    this.nameFieldEl = root.querySelector("[data-customizer-name-field]");
    this.numberFieldEl = root.querySelector("[data-customizer-number-field]");
    this.yearDadFieldEl = root.querySelector("[data-customizer-year-dad-field]");
    this.yearBabyFieldEl = root.querySelector("[data-customizer-year-baby-field]");
    this.yearMomFieldEl = root.querySelector("[data-customizer-year-mom-field]");
    this.playerNameFieldEl = root.querySelector("[data-customizer-player-name-field]");
    this.dadNameFieldEl = root.querySelector("[data-customizer-dad-name-field]");
    this.momNameFieldEl = root.querySelector("[data-customizer-mom-name-field]");
    this.childNameFieldEl = root.querySelector("[data-customizer-child-name-field]");
    this.dadNumberFieldEl = root.querySelector("[data-customizer-dad-number-field]");
    this.momNumberFieldEl = root.querySelector("[data-customizer-mom-number-field]");
    this.childNumberFieldEl = root.querySelector("[data-customizer-child-number-field]");
    this.tabsEl = root.querySelector("[data-customizer-zone-tabs]");
    this.editorZonesTitleEl = root.querySelector("[data-customizer-editor-zones-title]");
    this.editorCloseEls = root.querySelectorAll("[data-customizer-editor-close]");
    this.openEditorBtn = root.querySelector("[data-customizer-open-editor]");
    this.freeEditorEl = this.queryUI("[data-customizer-free-editor]");
    this.worldCupEditorEl = this.queryUI("[data-customizer-world-cup-editor]");
    this.totalEl = root.querySelector("[data-customizer-total]");
    this.filesEl = root.querySelector("[data-customizer-files]");
    this.sectionEl = root.closest(".shopify-section") || document;
    this.addToCartLabelEl = this.sectionEl.querySelector('button[name="add"] .hidden.md\\:block');
    this.addToCartBaseLabel = this.addToCartLabelEl ? this.addToCartLabelEl.textContent.trim() : "";

    this.hiddenFields = {
      type: root.querySelector("[data-customizer-field=\"type\"]"),
      zone: root.querySelector("[data-customizer-field=\"zone\"]"),
      vinyl: root.querySelector("[data-customizer-field=\"vinyl_color\"]"),
      garment: root.querySelector("[data-customizer-field=\"garment_color\"]"),
      flag: root.querySelector("[data-customizer-field=\"flag\"]"),
      name: root.querySelector("[data-customizer-field=\"name\"]"),
      number: root.querySelector("[data-customizer-field=\"number\"]"),
      yearDad: root.querySelector("[data-customizer-field=\"year_dad\"]"),
      yearBaby: root.querySelector("[data-customizer-field=\"year_baby\"]"),
      yearMom: root.querySelector("[data-customizer-field=\"year_mom\"]"),
      playerName: root.querySelector("[data-customizer-field=\"player_name\"]"),
      dadName: root.querySelector("[data-customizer-field=\"dad_name\"]"),
      momName: root.querySelector("[data-customizer-field=\"mom_name\"]"),
      childName: root.querySelector("[data-customizer-field=\"child_name\"]"),
      dadNumber: root.querySelector("[data-customizer-field=\"dad_number\"]"),
      momNumber: root.querySelector("[data-customizer-field=\"mom_number\"]"),
      childNumber: root.querySelector("[data-customizer-field=\"child_number\"]"),
      total: root.querySelector("[data-customizer-field=\"total_price\"]"),
      variantTitle: root.querySelector("[data-customizer-field=\"variant_title\"]"),
      variantId: root.querySelector("[data-customizer-field=\"variant_id\"]"),
      renderFile: null
    };

    this.baseImage = new Image();
    this.baseImage.crossOrigin = "anonymous";
    this.baseImage.onload = () => {
      this.render();
    };
    this.baseImage.src = this.baseImageUrl;
    if (this.baseImageUrl) this.baseImageCache.set(this.baseImageUrl, this.baseImage);

    if (this.editorOverlayEl && this.editorOverlayEl.parentNode !== document.body) {
      document.body.appendChild(this.editorOverlayEl);
    }

    this.setupUI();
    this.bindForm();
    this.bindVariantSync();
    this.renderVariantPicker();
    this.applyVariantState(this.currentVariant);
    this.updateEditorVisibility();
    this.render();

    this.bindAddonSync();
  }

  parseLines(value) {
    if (!value) return [];
    const parts = value.includes("||") ? value.split("||") : value.split(/\\r?\\n/);
    return parts
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => {
        const [label, rawValue] = line.split("|").map((part) => (part || "").trim());
        return { label, value: rawValue || label };
      });
  }

  parseZones(value) {
    if (!value) return [];
    const parts = value.includes("||") ? value.split("||") : value.split(/\\r?\\n/);
    return parts
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => {
        const [label, price, area, imageUrl, key] = line.split("|").map((part) => (part || "").trim());
        return { label, price, area, imageUrl, key };
      });
  }

  parseColors(value) {
    if (!value) return [];
    const parts = value.includes("||") ? value.split("||") : value.split(/\\r?\\n/);
    return parts
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => {
        const [label, color] = line.split("|").map((part) => (part || "").trim());
        return { label, value: color || label };
      });
  }

  parseCurrentVariant() {
    return this.parseJsonScript("[data-customizer-current-variant]", null);
  }

  queryUI(selector) {
    return this.root.querySelector(selector) || this.editorOverlayEl?.querySelector(selector) || null;
  }

  parseProductZoneKeys(value) {
    if (!value) return [];
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed.map((item) => String(item || "").trim()).filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  getWorldCupCountries() {
    return Array.isArray(this.worldCupConfig?.countries)
      ? this.worldCupConfig.countries.filter((item) => item && item.code && item.label)
      : [];
  }

  populateWorldCupCountries() {
    if (!this.worldCupCountryInput) return;
    const countries = this.getWorldCupCountries();
    this.worldCupCountryInput.innerHTML = `<option value="">Selecciona un país</option>${countries
      .map((item) => `<option value="${String(item.code).replace(/"/g, "&quot;")}">${item.label}</option>`)
      .join("")}`;
  }

  getWorldCupCountry(code) {
    return this.getWorldCupCountries().find((item) => String(item.code) === String(code || "")) || null;
  }

  getCurrentVariantWorldCupTextColor() {
    const variantId = String(this.currentVariant?.id || "").trim();
    if (!variantId) return "";
    return this.normalizeHexColor(this.variantWorldCupColors?.[variantId] || "");
  }

  normalizeWorldCupZoneKey(zoneKey) {
    const normalized = String(zoneKey || "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[\s-]+/g, "_");
    if (normalized === "delante") return "delante_centro";
    if (normalized === "detras") return "espalda";
    return normalized;
  }

  parseWorldCupLayout(value) {
    if (!value) return null;
    if (typeof value === "object") return value;
    try {
      return JSON.parse(value);
    } catch (error) {
      const normalized = String(value || "").trim();
      if (!normalized) return null;
      const result = {};
      normalized.split(";").forEach((chunk) => {
        const [keyRaw, valuesRaw] = chunk.split(":");
        const key = String(keyRaw || "").trim();
        const values = String(valuesRaw || "")
          .split(",")
          .map((item) => Number(String(item).trim()));
        if (!key || values.some((item) => Number.isNaN(item))) return;
        if (key === "crest" && values.length >= 3) {
          result.crest = { x: values[0], y: values[1], w: values[2] };
        }
        if ((key === "name" || key === "number") && values.length >= 3) {
          result[key] = { x: values[0], y: values[1], size: values[2] };
        }
      });
      return Object.keys(result).length ? result : null;
    }
  }

  getWorldCupLayout(zoneKey) {
    const normalizedKey = this.normalizeWorldCupZoneKey(zoneKey);
    const layout = this.parseWorldCupLayout(this.worldCupConfig?.layouts?.[normalizedKey]) || null;
    if (!layout) return null;

    const sizeConfig = this.worldCupConfig?.text?.sizes?.[normalizedKey] || {};
    if (layout.name && sizeConfig.name != null && sizeConfig.name !== "") {
      layout.name.size = Number(sizeConfig.name) || layout.name.size;
    }
    if (layout.number && sizeConfig.number != null && sizeConfig.number !== "") {
      layout.number.size = Number(sizeConfig.number) || layout.number.size;
    }
    return layout;
  }

  getWorldCupVisibility(zoneKey) {
    const normalizedKey = this.normalizeWorldCupZoneKey(zoneKey);
    const raw = this.worldCupConfig?.visibility?.[normalizedKey] || {};
    const layout = this.getWorldCupLayout(normalizedKey) || {};
    const defaults = normalizedKey === "espalda"
      ? { country: false, name: true, number: true }
      : { country: true, name: true, number: true };
    const explicitCountry = typeof raw.country === "boolean" ? raw.country : defaults.country;
    const explicitName = typeof raw.name === "boolean" ? raw.name : defaults.name;
    const explicitNumber = typeof raw.number === "boolean" ? raw.number : defaults.number;
    return {
      country: explicitCountry && !!layout.crest,
      name: explicitName && !!layout.name,
      number: explicitNumber && !!layout.number
    };
  }

  setElementVisibility(el, visible) {
    if (!el) return;
    el.hidden = !visible;
    el.style.display = visible ? "" : "none";
  }

  getCachedImage(url) {
    if (!url) return null;
    const cached = this.baseImageCache.get(url);
    if (cached) return cached;
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => this.render();
    image.src = url;
    this.baseImageCache.set(url, image);
    return image;
  }

  normalizeHexColor(value) {
    const raw = String(value || "").trim();
    if (!raw) return null;
    const prefixed = raw.startsWith("#") ? raw : `#${raw}`;
    if (!/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(prefixed)) return null;
    if (prefixed.length === 4) {
      return `#${prefixed[1]}${prefixed[1]}${prefixed[2]}${prefixed[2]}${prefixed[3]}${prefixed[3]}`.toLowerCase();
    }
    return prefixed.toLowerCase();
  }

  parseJsonScript(selector, fallback) {
    const node = this.root.querySelector(selector);
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || "null") ?? fallback;
    } catch (error) {
      return fallback;
    }
  }

  normalizeZoneKey(value) {
    const normalized = String(value || "")
      .toLowerCase()
      .trim()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ");

    if (normalized.includes("delantera izquierda")) return "delantera_izquierda";
    if (normalized.includes("delantera derecha")) return "delantera_derecha";
    if (normalized.includes("delante centro") || normalized === "delante" || normalized === "frontal" || normalized === "front") return "delante_centro";
    if (normalized.includes("espalda") || normalized.includes("detras") || normalized.includes("detrás") || normalized === "back") return "espalda";
    if (normalized.includes("cuello") || normalized.includes("nuca")) return "cuello_nuca";
    if (normalized.includes("brazo") || normalized.includes("manga")) return "brazo";
    return "";
  }

  filterZonesForProduct(zones) {
    if (!Array.isArray(zones) || !zones.length) return [];
    const allowed = this.productZoneKeys.length
      ? new Set(this.productZoneKeys.map((key) => this.normalizeZoneKey(key)).filter(Boolean))
      : null;
    const seen = new Set();

    return zones.filter((zone) => {
      const zoneKey = this.normalizeZoneKey(zone.key || zone.label);
      if (zoneKey) {
        if (allowed && !allowed.has(zoneKey)) return false;
        if (seen.has(zoneKey)) return false;
        zone.key = zoneKey;
        seen.add(zoneKey);
        return true;
      }

      const fallbackKey = `label:${String(zone.label || "").toLowerCase().trim()}`;
      if (seen.has(fallbackKey)) return false;
      seen.add(fallbackKey);
      return !allowed;
    });
  }

  setupUI() {
    this.typesContainer = this.root.querySelector("[data-customizer-types]");
    this.zonesContainer = this.root.querySelector("[data-customizer-zones]");
    this.zonesModalContainer = this.queryUI("[data-customizer-zones-modal]");
    this.materialLabelEl = this.root.querySelector("[data-customizer-material-label]");
    this.buildChips(this.typesContainer, this.types, "type");
    this.buildChips(this.zonesContainer, this.zones, "zone");
    this.buildChips(this.zonesModalContainer, this.zones, "zone");
    this.buildSwatches(this.root.querySelector("[data-customizer-vinyl-colors]"), this.vinylColors, "vinylColor");
    this.buildSwatches(this.root.querySelector("[data-customizer-garment-colors]"), this.garmentColors, "garmentColor");

    const flagInput = this.root.querySelector("[data-customizer-flag]");
    if (flagInput) {
      flagInput.addEventListener("change", (e) => {
        this.state.flag = e.target.checked;
        this.syncHiddenFields();
      });
    }

    const uploadInput = this.queryUI("[data-customizer-upload]");
    if (uploadInput) {
      uploadInput.addEventListener("click", () => {
        uploadInput.value = "";
      });
      uploadInput.addEventListener("change", (e) => this.handleImageUpload(e));
    }

    this.textInput = this.queryUI("[data-customizer-text-input]");
    this.addTextBtn = this.queryUI("[data-customizer-add-text]");
    this.textLayersEl = this.queryUI("[data-customizer-text-layers]");
    this.imageLayersEl = this.queryUI("[data-customizer-image-layers]");
    this.textLayersSectionEl = this.queryUI("[data-customizer-text-layers-section]");
    this.imageLayersSectionEl = this.queryUI("[data-customizer-image-layers-section]");
    this.worldCupCountryFieldEl = this.queryUI("[data-customizer-world-cup-country-field]");
    this.worldCupNameFieldEl = this.queryUI("[data-customizer-world-cup-name-field]");
    this.worldCupNumberFieldEl = this.queryUI("[data-customizer-world-cup-number-field]");
    this.worldCupCountryInput = this.queryUI("[data-customizer-world-cup-country]");
    this.worldCupNameInput = this.queryUI("[data-customizer-world-cup-name]");
    this.worldCupNumberInput = this.queryUI("[data-customizer-world-cup-number]");
    if (!this.worldCupCountryFieldEl && this.worldCupCountryInput) this.worldCupCountryFieldEl = this.worldCupCountryInput.closest(".product-customizer__toolbar-field");
    if (!this.worldCupNameFieldEl && this.worldCupNameInput) this.worldCupNameFieldEl = this.worldCupNameInput.closest(".product-customizer__toolbar-field");
    if (!this.worldCupNumberFieldEl && this.worldCupNumberInput) this.worldCupNumberFieldEl = this.worldCupNumberInput.closest(".product-customizer__toolbar-field");
    this.nameInput = this.queryUI("[data-customizer-name-input]");
    this.numberInput = this.queryUI("[data-customizer-number-input]");
    this.yearDadInput = this.queryUI("[data-customizer-year-dad-input]");
    this.yearBabyInput = this.queryUI("[data-customizer-year-baby-input]");
    this.yearMomInput = this.queryUI("[data-customizer-year-mom-input]");
    this.playerNameInput = this.queryUI("[data-customizer-player-name-input]");
    this.dadNameInput = this.queryUI("[data-customizer-dad-name-input]");
    this.momNameInput = this.queryUI("[data-customizer-mom-name-input]");
    this.childNameInput = this.queryUI("[data-customizer-child-name-input]");
    this.dadNumberInput = this.queryUI("[data-customizer-dad-number-input]");
    this.momNumberInput = this.queryUI("[data-customizer-mom-number-input]");
    this.childNumberInput = this.queryUI("[data-customizer-child-number-input]");
    this.textFontInput = this.queryUI("[data-customizer-text-font]");
    this.textSizeInput = this.queryUI("[data-customizer-text-size]");
    this.textColorInput = this.queryUI("[data-customizer-text-color]");
    this.textColorHexInput = this.queryUI("[data-customizer-text-color-hex]");

    if (this.textInput) {
      this.textInput.addEventListener("focus", () => {
        const zone = this.getCurrentZoneState();
        const layer = this.getSelectedTextLayer(zone) || this.getZoneTextLayers(zone)[0];
        if (zone && layer) {
          this.selected = `text:${layer.id}`;
          this.render();
        }
      });
      this.textInput.addEventListener("input", (e) => {
        const zone = this.getCurrentZoneState();
        if (!zone) return;
        let layer = this.getSelectedTextLayer(zone);
        if (!layer) layer = this.addTextLayer(zone);
        layer.value = e.target.value || "";
        this.selected = `text:${layer.id}`;
        this.syncHiddenFields();
        this.updateTextLayersUI();
        this.render();
      });
    }

    if (this.worldCupCountryInput) {
      this.populateWorldCupCountries();
      this.worldCupCountryInput.addEventListener("change", (e) => {
        const zone = this.getCurrentZoneState();
        if (!zone) return;
        zone.worldCup.country = e.target.value || "";
        this.syncHiddenFields();
        this.render();
      });
    }

    if (this.worldCupNameInput) {
      this.worldCupNameInput.addEventListener("input", (e) => {
        const zone = this.getCurrentZoneState();
        if (!zone) return;
        zone.worldCup.name = e.target.value || "";
        this.syncHiddenFields();
        this.render();
      });
    }

    if (this.worldCupNumberInput) {
      this.worldCupNumberInput.addEventListener("input", (e) => {
        const zone = this.getCurrentZoneState();
        if (!zone) return;
        zone.worldCup.number = e.target.value || "";
        this.syncHiddenFields();
        this.render();
      });
    }

    if (this.addTextBtn) {
      this.addTextBtn.addEventListener("click", () => {
        const zone = this.getCurrentZoneState();
        if (!zone) return;
        const layer = this.addTextLayer(zone);
        this.selected = `text:${layer.id}`;
        this.loadZoneToInputs();
        this.updateTextLayersUI();
        this.render();
        if (this.textInput) this.textInput.focus();
      });
    }

    if (this.nameInput) {
      this.nameInput.addEventListener("input", (e) => {
        this.state.name = e.target.value || "";
        this.syncHiddenFields();
      });
    }

    if (this.numberInput) {
      this.numberInput.addEventListener("input", (e) => {
        this.state.number = e.target.value || "";
        this.syncHiddenFields();
      });
    }

    if (this.yearDadInput) {
      this.yearDadInput.addEventListener("input", (e) => {
        this.state.yearDad = e.target.value || "";
        this.syncHiddenFields();
      });
    }

    if (this.yearBabyInput) {
      this.yearBabyInput.addEventListener("input", (e) => {
        this.state.yearBaby = e.target.value || "";
        this.syncHiddenFields();
      });
    }

    if (this.yearMomInput) {
      this.yearMomInput.addEventListener("input", (e) => {
        this.state.yearMom = e.target.value || "";
        this.syncHiddenFields();
      });
    }

    if (this.playerNameInput) {
      this.playerNameInput.addEventListener("input", (e) => {
        this.state.playerName = e.target.value || "";
        this.syncHiddenFields();
      });
    }

    if (this.dadNameInput) {
      this.dadNameInput.addEventListener("input", (e) => {
        this.state.dadName = e.target.value || "";
        this.syncHiddenFields();
      });
    }

    if (this.momNameInput) {
      this.momNameInput.addEventListener("input", (e) => {
        this.state.momName = e.target.value || "";
        this.syncHiddenFields();
      });
    }

    if (this.childNameInput) {
      this.childNameInput.addEventListener("input", (e) => {
        this.state.childName = e.target.value || "";
        this.syncHiddenFields();
      });
    }

    if (this.dadNumberInput) {
      this.dadNumberInput.addEventListener("input", (e) => {
        this.state.dadNumber = e.target.value || "";
        this.syncHiddenFields();
      });
    }

    if (this.momNumberInput) {
      this.momNumberInput.addEventListener("input", (e) => {
        this.state.momNumber = e.target.value || "";
        this.syncHiddenFields();
      });
    }

    if (this.childNumberInput) {
      this.childNumberInput.addEventListener("input", (e) => {
        this.state.childNumber = e.target.value || "";
        this.syncHiddenFields();
      });
    }

    if (this.textFontInput) {
      this.state.textFont = this.textFontInput.value || "sans-serif";
      this.ensureTextFontLoaded();
      this.textFontInput.addEventListener("change", (e) => {
        this.state.textFont = e.target.value || "sans-serif";
        const layer = this.getSelectedTextLayer();
        if (layer) layer.font = this.state.textFont;
        this.ensureTextFontLoaded().then(() => this.render());
      });
    }

    if (this.textSizeInput) {
      this.textSizeInput.addEventListener("input", (e) => {
        const nextValue = Number(e.target.value || 28);
        this.state.textSize = Math.min(96, Math.max(12, nextValue || 28));
        const layer = this.getSelectedTextLayer();
        if (layer) layer.size = this.state.textSize;
        this.render();
      });
    }

    if (this.textColorInput) {
      this.textColorInput.addEventListener("input", (e) => {
        this.state.textColor = e.target.value || "#111111";
        const layer = this.getSelectedTextLayer();
        if (layer) layer.color = this.state.textColor;
        if (this.textColorHexInput) this.textColorHexInput.value = this.state.textColor.toUpperCase();
        this.render();
      });
    }

    if (this.textColorHexInput) {
      this.textColorHexInput.addEventListener("input", (e) => {
        const normalized = this.normalizeHexColor(e.target.value);
        if (!normalized) return;
        this.state.textColor = normalized;
        const layer = this.getSelectedTextLayer();
        if (layer) layer.color = normalized;
        if (this.textColorInput) this.textColorInput.value = normalized;
        e.target.value = normalized.toUpperCase();
        this.render();
      });

      this.textColorHexInput.addEventListener("blur", (e) => {
        const normalized = this.normalizeHexColor(e.target.value) || this.state.textColor || "#111111";
        e.target.value = normalized.toUpperCase();
      });
    }

    const clearImageBtn = this.queryUI("[data-customizer-clear-image]");
    if (clearImageBtn) {
      clearImageBtn.addEventListener("click", () => {
        const zone = this.getCurrentZoneState();
        if (!zone) return;
        const imageLayer = this.getSelectedImageLayer(zone) || this.getZoneImageLayers(zone).at(-1);
        if (!imageLayer) return;
        zone.images = this.getZoneImageLayers(zone).filter((item) => item.id !== imageLayer.id);
        this.selected = zone.images[0] ? `image:${zone.images[zone.images.length - 1].id}` : zone.texts[0] ? `text:${zone.texts[0].id}` : null;
        this.updateImageLayersUI();
        this.render();
        this.syncHiddenFields();
      });
    }

    const clearTextBtn = this.queryUI("[data-customizer-clear-text]");
    if (clearTextBtn) {
      clearTextBtn.addEventListener("click", () => {
        const zone = this.getCurrentZoneState();
        if (!zone) return;
        const layer = this.getSelectedTextLayer(zone) || this.getZoneTextLayers(zone).at(-1);
        if (!layer) return;
        zone.texts = this.getZoneTextLayers(zone).filter((item) => item.id !== layer.id);
        this.selected = this.getZoneImageLayers(zone)[0]
          ? `image:${this.getZoneImageLayers(zone).at(-1).id}`
          : this.getZoneTextLayers(zone)[0]
            ? `text:${this.getZoneTextLayers(zone)[0].id}`
            : null;
        this.loadZoneToInputs();
        this.updateTextLayersUI();
        this.render();
        this.syncHiddenFields();
      });
    }

    const resetBtn = this.queryUI("[data-customizer-reset]");
    if (resetBtn) {
      resetBtn.addEventListener("click", () => {
        const zone = this.getCurrentZoneState();
        if (!zone) return;
        this.resetImagePosition(zone);
        this.resetTextPosition(zone);
        this.render();
      });
    }

    this.bindCanvasDrag();

    if (this.editorCloseEls?.length) {
      this.editorCloseEls.forEach((el) => {
        el.addEventListener("click", () => this.closeEditorOverlay());
      });
    }

    if (this.openEditorBtn) {
      this.openEditorBtn.addEventListener("click", () => this.openEditorOverlay());
    }

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") this.closeEditorOverlay();
    });
  }

  openEditorOverlay() {
    if (!this.editorOverlayEl || !this.editorEl || this.editorEl.hidden) return;
    if (!this.zonesSelected.size && Array.isArray(this.zones) && this.zones.length) {
      const firstZone = this.zones[0];
      if (firstZone) {
        const zoneState = this.createZoneState(firstZone);
        this.zonesSelected.set(firstZone.label, zoneState);
        this.currentZone = firstZone.label;
        this.selected = null;
        this.syncZoneButtonsSelection();
        this.updateCurrentZoneArea();
        this.loadZoneImage();
        this.updateZoneTabs();
        this.updateEditorVisibility();
        this.loadZoneToInputs();
        this.syncHiddenFields();
      }
    }
    if (!this.currentZone && this.zonesSelected.size) {
      this.currentZone = this.zonesSelected.keys().next().value || null;
    }
    if (!this.selected) {
      const zone = this.getCurrentZoneState();
      if (zone) {
        const imageLayers = this.getZoneImageLayers(zone);
        const textLayers = this.getZoneTextLayers(zone);
        this.selected = imageLayers.length
          ? `image:${imageLayers[imageLayers.length - 1].id}`
          : textLayers.length
            ? `text:${textLayers[textLayers.length - 1].id}`
            : null;
      }
    }
    this.editorOverlayEl.hidden = false;
    document.body.classList.add("product-customizer--editor-open");
    this.updateZoneTabs();
    this.loadZoneToInputs();
    this.render();
  }

  closeEditorOverlay() {
    if (!this.editorOverlayEl || this.editorOverlayEl.hidden) return;
    this.editorOverlayEl.hidden = true;
    document.body.classList.remove("product-customizer--editor-open");
  }

  shouldShowMode(mode) {
    const hasType = !!this.state.type;
    const hasZone = this.zonesSelected.size > 0;
    if (mode === "hide") return false;
    if (mode === "start") return true;
    if (mode === "type") return hasType;
    return hasZone;
  }

  async ensureTextFontLoaded() {
    if (!document.fonts || !this.state.textFont) return;
    const fontDeclaration = this.getCanvasFont(this.state.textSize || 28);
    this.fontLoadPromise = document.fonts.load(fontDeclaration);
    try {
      await this.fontLoadPromise;
    } catch (error) {
      // ignore and let canvas fall back if the font can't be loaded
    }
  }

  getCanvasFont(size) {
    return `${size}px ${this.state.textFont || "sans-serif"}`;
  }

  buildChips(container, items, field) {
    if (!container || !items.length) return;
    container.innerHTML = "";
    items.forEach((item) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "product-customizer__chip";
      const labelWithoutPrice = this.enablePriceIncrement ? item.label : this.removePriceFromLabel(item.label);
      const hasPrice = item.price && labelWithoutPrice && labelWithoutPrice.includes(item.price);
      button.textContent = labelWithoutPrice + (this.enablePriceIncrement && item.price && !hasPrice ? ` (${item.price})` : "");
      button.dataset.value = item.label;
      if (field === "zone") button.dataset.customizerZoneButton = item.label;
      if (field === "zone" && this.zonesSelected.has(item.label)) {
        button.classList.add("is-selected");
      }
      button.addEventListener("click", () => {
        if (field === "zone") {
          this.toggleZoneSelection(item, button);
          return;
        }
        this.setActiveChip(container, button);
        this.state[field] = item.label;
        if (field === "type") {
          this.updateZonesForType(item.label);
        }
        this.syncHiddenFields();
      });
      container.appendChild(button);
    });
  }

  syncZoneButtonsSelection() {
    [this.zonesContainer, this.zonesModalContainer].forEach((container) => {
      if (!container) return;
      container.querySelectorAll("[data-customizer-zone-button]").forEach((button) => {
        const label = button.dataset.customizerZoneButton || "";
        button.classList.toggle("is-selected", this.zonesSelected.has(label));
      });
    });
  }

  updateZonesForType(typeLabel) {
    const isBordado = String(typeLabel || "").toLowerCase().includes("bordado");
    const nextZones = isBordado && this.zonesBordado.length ? this.zonesBordado : this.zonesVinyl;
    this.zones = nextZones;
    this.zonesSelected.clear();
    this.currentZone = null;
    this.selected = null;
    this.buildChips(this.zonesContainer, this.zones, "zone");
    this.buildChips(this.zonesModalContainer, this.zones, "zone");
    if (this.materialLabelEl) {
      this.materialLabelEl.textContent = isBordado ? this.bordadoLabel : this.vinylLabel;
    }
    this.updateZoneTabs();
    this.updateEditorVisibility();
    this.updateCurrentZoneArea();
    this.syncHiddenFields();
  }

  buildSwatches(container, items, field) {
    if (!container || !items.length) return;
    container.innerHTML = "";
    items.forEach((item) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "product-customizer__swatch";
      button.style.background = item.value;
      button.title = item.label;
      button.dataset.value = item.label;
      button.addEventListener("click", () => {
        this.setActiveSwatch(container, button);
        this.state[field] = item.label;
        this.syncHiddenFields();
      });
      container.appendChild(button);
    });
  }

  renderVariantPicker() {
    if (!this.showIntegratedVariantPicker || !this.variantPickerEl || !this.productOptions.length || !this.productVariants.length) return;

    const selectedVariant = this.currentVariant || this.productVariants[0];
    const selectedOptions = this.getSelectedOptionsMap(selectedVariant);
    const sortedOptions = this.getSortedVisibleOptions();

    this.variantPickerEl.innerHTML = "";

    sortedOptions.forEach(({ option, optionIndex }) => {
      const field = document.createElement("div");
      field.className = "product-customizer__variant-field";

      const currentValue = selectedOptions[optionIndex] || option.selected_value || "";
      const label = document.createElement("div");
      label.className = "product-customizer__variant-label";
      label.innerHTML = `${this.getOptionDisplayName(option.name)}: <span>${currentValue}</span>`;
      field.appendChild(label);

      const valuesWrap = document.createElement("div");
      const isColor = this.isColorOption(option.name);
      valuesWrap.className = isColor ? "product-customizer__variant-values product-customizer__variant-values--color" : "product-customizer__variant-values";

      option.values.forEach((rawValue) => {
        const value = typeof rawValue === "string" ? rawValue : rawValue?.name || rawValue?.value || "";
        const state = this.getOptionValueState(optionIndex, value, selectedOptions);
        const button = document.createElement("button");
        button.type = "button";
        const useColorImage = isColor && this.variantPickerColorStyle === "image";
        button.className = useColorImage ? "product-customizer__variant-color" : "product-customizer__variant-chip";
        if (state.selected) button.classList.add("is-active");
        if (!state.available) button.classList.add("is-disabled");
        button.disabled = !state.available;
        button.id = `customizer-variant-${this.formId}-${optionIndex}-${this.safeSlug(value)}`;
        button.dataset.optionIndex = String(optionIndex);
        button.dataset.value = value;

        if (useColorImage) {
          const previewImage = this.getOptionValuePreviewImage(optionIndex, value);
          if (previewImage) {
            const img = document.createElement("img");
            img.src = previewImage;
            img.alt = value;
            button.appendChild(img);
          } else {
            button.textContent = value;
          }
          const caption = document.createElement("span");
          caption.className = "product-customizer__variant-color-label";
          caption.textContent = value;
          button.appendChild(caption);
        } else {
          button.textContent = value;
        }

        button.addEventListener("click", () => this.selectVariantOption(optionIndex, value));
        valuesWrap.appendChild(button);
      });

      field.appendChild(valuesWrap);
      this.variantPickerEl.appendChild(field);
    });
  }

  setActiveChip(container, button) {
    container.querySelectorAll(".product-customizer__chip").forEach((el) => el.classList.remove("is-active"));
    button.classList.add("is-active");
  }

  setActiveSwatch(container, button) {
    container.querySelectorAll(".product-customizer__swatch").forEach((el) => el.classList.remove("is-active"));
    button.classList.add("is-active");
  }

  parseArea(areaString) {
    if (!areaString) return null;
    const parts = areaString.split(",").map((v) => Number(String(v).trim()));
    if (parts.length !== 4 || parts.some((v) => Number.isNaN(v))) return null;
    return { x: parts[0] / 100, y: parts[1] / 100, w: parts[2] / 100, h: parts[3] / 100 };
  }

  resetImagePosition(zone) {
    const layer = this.getSelectedImageLayer(zone) || this.getZoneImageLayers(zone)[0];
    if (!zone || !layer) return;
    layer.pos = { x: 0.5, y: 0.5 };
    layer.size = this.getImageLayerInitialSize(layer.image);
    this.clampImageLayerToZone(layer);
  }

  getZoneImageLayers(zone = this.getCurrentZoneState()) {
    if (!zone) return [];
    if (!Array.isArray(zone.images)) zone.images = [];
    return zone.images;
  }

  createImageLayer(zone, image) {
    zone.nextImageId = Number(zone.nextImageId || 0) + 1;
    return {
      id: `i${zone.nextImageId}`,
      image,
      pos: { x: 0.5, y: 0.5 },
      size: this.getImageLayerInitialSize(image),
      aspectRatio: this.getImageAspectRatio(image)
    };
  }

  getImageAspectRatio(image) {
    const width = Number(image?.naturalWidth || image?.width || 0);
    const height = Number(image?.naturalHeight || image?.height || 0);
    return width > 0 && height > 0 ? width / height : 1;
  }

  getImageLayerInitialSize(image) {
    const baseRect = this.getBaseRect();
    const imageRatio = this.getImageAspectRatio(image);
    const baseRatio = baseRect?.w && baseRect?.h ? baseRect.w / baseRect.h : 1;
    let w = 0.3;
    let h = imageRatio > 0 ? (w / imageRatio) * baseRatio : w;

    if (this.state.zoneArea) {
      const maxW = Math.min(0.3, this.state.zoneArea.w);
      const maxH = this.state.zoneArea.h;
      w = Math.min(w, maxW);
      h = imageRatio > 0 ? (w / imageRatio) * baseRatio : w;

      if (h > maxH) {
        h = maxH;
        w = imageRatio > 0 ? (h * imageRatio) / baseRatio : h;
      }
    }

    return { w: Math.max(0.02, w), h: Math.max(0.02, h) };
  }

  addImageLayer(zone, image) {
    const layer = this.createImageLayer(zone, image);
    this.getZoneImageLayers(zone).push(layer);
    return layer;
  }

  getSelectedImageId() {
    if (typeof this.selected !== "string" || !this.selected.startsWith("image:")) return "";
    return this.selected.slice(6);
  }

  getSelectedImageLayer(zone = this.getCurrentZoneState()) {
    const imageId = this.getSelectedImageId();
    if (!imageId || !zone) return null;
    return this.getZoneImageLayers(zone).find((item) => item.id === imageId) || null;
  }

  getImageLayerByToken(token, zone = this.getCurrentZoneState()) {
    if (!zone || typeof token !== "string" || !token.startsWith("image:")) return null;
    const imageId = token.slice(6);
    return this.getZoneImageLayers(zone).find((item) => item.id === imageId) || null;
  }

  updateImageLayersUI() {
    if (!this.imageLayersEl) return;
    const zone = this.getCurrentZoneState();
    const layers = this.getZoneImageLayers(zone);
    this.imageLayersEl.innerHTML = "";
    if (this.imageLayersSectionEl) this.imageLayersSectionEl.hidden = !layers.length;
    if (!layers.length) return;
    layers.forEach((layer, index) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "product-customizer__image-layer";
      if (this.getSelectedImageId() === layer.id) button.classList.add("is-active");
      button.textContent = `Imagen ${index + 1}`;
      button.addEventListener("click", () => {
        this.selected = `image:${layer.id}`;
        this.updateImageLayersUI();
        this.render();
      });
      this.imageLayersEl.appendChild(button);
    });
  }

  resetTextPosition(zone) {
    const layer = this.getSelectedTextLayer(zone) || this.getZoneTextLayers(zone)[0];
    if (!zone || !layer) return;
    layer.pos = { x: 0.5, y: 0.5 };
    layer.scale = 1;
  }

  getZoneTextLayers(zone = this.getCurrentZoneState()) {
    if (!zone) return [];
    if (!Array.isArray(zone.texts)) zone.texts = [];
    return zone.texts;
  }

  createTextLayer(zone, value = "") {
    zone.nextTextId = Number(zone.nextTextId || 0) + 1;
    return {
      id: `t${zone.nextTextId}`,
      value,
      pos: { x: 0.5, y: 0.5 },
      scale: 1,
      color: this.state.textColor || "#111111",
      font: this.state.textFont || "sans-serif",
      size: this.state.textSize || 28
    };
  }

  addTextLayer(zone, value = "") {
    const layer = this.createTextLayer(zone, value);
    this.getZoneTextLayers(zone).push(layer);
    return layer;
  }

  getSelectedTextId() {
    if (typeof this.selected !== "string" || !this.selected.startsWith("text:")) return "";
    return this.selected.slice(5);
  }

  getSelectedTextLayer(zone = this.getCurrentZoneState()) {
    const textId = this.getSelectedTextId();
    if (!textId || !zone) return null;
    return this.getZoneTextLayers(zone).find((item) => item.id === textId) || null;
  }

  getTextLayerByToken(token, zone = this.getCurrentZoneState()) {
    if (!zone || typeof token !== "string" || !token.startsWith("text:")) return null;
    const textId = token.slice(5);
    return this.getZoneTextLayers(zone).find((item) => item.id === textId) || null;
  }

  getTextLines(value) {
    return String(value || "").split(/\r?\n/);
  }

  getTextLayerLabel(layer, index) {
    const firstLine = this.getTextLines(layer?.value || "").find((line) => line.trim()) || "";
    return firstLine ? firstLine.slice(0, 24) : `Texto ${index + 1}`;
  }

  updateTextLayersUI() {
    if (!this.textLayersEl) return;
    const zone = this.getCurrentZoneState();
    const layers = this.getZoneTextLayers(zone);
    this.textLayersEl.innerHTML = "";
    if (this.textLayersSectionEl) this.textLayersSectionEl.hidden = !layers.length;
    if (!layers.length) return;
    layers.forEach((layer, index) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "product-customizer__text-layer";
      if (this.getSelectedTextId() === layer.id) button.classList.add("is-active");
      button.textContent = this.getTextLayerLabel(layer, index);
      button.addEventListener("click", () => {
        this.selected = `text:${layer.id}`;
        this.loadZoneToInputs();
        this.updateTextLayersUI();
        this.render();
      });
      this.textLayersEl.appendChild(button);
    });
  }

  handleImageUpload(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        if (!this.currentZone && this.zonesSelected.size) {
          this.currentZone = this.zonesSelected.keys().next().value || null;
        }
        const zone = this.getCurrentZoneState();
        if (!zone) return;
        const layer = this.addImageLayer(zone, img);
        layer.sourceFile = file;
        this.selected = `image:${layer.id}`;
        this.resetImagePosition(zone);
        this.updateZoneTabs();
        this.loadZoneImage();
        this.loadZoneToInputs();
        this.updateImageLayersUI();
        this.render();
        this.syncHiddenFields();
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
    event.target.value = "";
  }

  bindCanvasDrag() {
    let dragging = null;
    let resizing = null;
    let last = { x: 0, y: 0 };
    let activePointerId = null;
    const supportsPointer = typeof window !== "undefined" && "PointerEvent" in window;

    const start = (pos) => {
      if (this.worldCupMode) {
        this.selected = null;
        this.render();
        return;
      }
      const selectedResizeHit = this.hitTestSelectedResize(pos);
      if (selectedResizeHit) {
        resizing = selectedResizeHit;
        last = pos;
        return;
      }
      const anyHandleHit = this.hitTestAnyResize(pos);
      if (anyHandleHit) {
        this.selected = anyHandleHit.target;
        resizing = anyHandleHit;
        last = pos;
        this.render();
        return;
      }
      const target = this.hitTest(pos);
      if (target && target !== this.selected) {
        this.selected = target;
        this.render();
      }
      const handleHit = this.hitTestHandle(pos);
      if (handleHit) {
        resizing = handleHit;
        last = pos;
        return;
      }
      if (target) {
        dragging = target;
        this.selected = target;
        last = pos;
        this.render();
      } else {
        this.selected = null;
        this.render();
      }
    };

    const move = (pos) => {
      if (!dragging && !resizing) return;
      const dx = pos.x - last.x;
      const dy = pos.y - last.y;
      last = pos;
      if (resizing) {
        this.resizeElement(resizing.target, resizing.handle, dx, dy);
        return;
      }
      if (dragging) {
        this.moveElement(dragging, dx, dy);
      }
    };

    const end = () => {
      dragging = null;
      resizing = null;
    };

    const getPos = (e) => this.getCanvasPos(e);

    if (supportsPointer) {
      this.canvas.addEventListener("pointerdown", (e) => {
        e.preventDefault();
        activePointerId = e.pointerId;
        if (typeof this.canvas.setPointerCapture === "function") {
          this.canvas.setPointerCapture(e.pointerId);
        }
        start(getPos(e));
      });
      this.canvas.addEventListener("pointermove", (e) => {
        e.preventDefault();
        move(getPos(e));
      });
      this.canvas.addEventListener("pointerup", (e) => {
        e.preventDefault();
        if (activePointerId !== null && typeof this.canvas.releasePointerCapture === "function") {
          try {
            this.canvas.releasePointerCapture(activePointerId);
          } catch (error) {
            // ignore release failures
          }
        }
        activePointerId = null;
        end();
      });
      this.canvas.addEventListener("pointercancel", end);
      return;
    }

    this.canvas.addEventListener("mousedown", (e) => {
      e.preventDefault();
      start(getPos(e));
    });
    window.addEventListener("mousemove", (e) => move(getPos(e)));
    window.addEventListener("mouseup", end);

    this.canvas.addEventListener(
      "touchstart",
      (e) => {
        e.preventDefault();
        const t = e.touches[0];
        if (!t) return;
        start(this.getCanvasPos(t));
      },
      { passive: false }
    );
    window.addEventListener(
      "touchmove",
      (e) => {
        const t = e.touches[0];
        if (!t) return;
        move(this.getCanvasPos(t));
      },
      { passive: false }
    );
    window.addEventListener("touchend", end);
  }

  getCanvasPos(event) {
    const rect = this.canvas.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * this.canvas.width;
    const y = ((event.clientY - rect.top) / rect.height) * this.canvas.height;
    return { x, y };
  }

  hitTest(pos) {
    const zone = this.getCurrentZoneState();
    if (!zone) return null;
    const elements = [];
    this.getZoneImageLayers(zone).forEach((layer) => elements.push(`image:${layer.id}`));
    this.getZoneTextLayers(zone).forEach((layer) => elements.push(`text:${layer.id}`));
    for (let i = elements.length - 1; i >= 0; i -= 1) {
      const el = elements[i];
      const bounds = this.getElementBounds(el);
      if (bounds) {
        const pad = bounds.pad || 0;
        if (pos.x >= bounds.x - pad && pos.x <= bounds.x + bounds.w + pad && pos.y >= bounds.y - pad && pos.y <= bounds.y + bounds.h + pad) {
          return el;
        }
      }
    }
    return null;
  }

  moveElement(element, dx, dy) {
    const baseRect = this.getBaseRect();
    if (!baseRect) return;
    const zone = this.getCurrentZoneState();
    if (!zone) return;
    if (typeof element === "string" && element.startsWith("image:")) {
      const layer = this.getImageLayerByToken(element, zone);
      if (!layer) return;
      layer.pos.x += dx / baseRect.w;
      layer.pos.y += dy / baseRect.h;
      this.clampImageLayerToZone(layer);
    } else if (typeof element === "string" && element.startsWith("text:")) {
      const layer = this.getTextLayerByToken(element, zone);
      if (!layer) return;
      layer.pos.x += dx / baseRect.w;
      layer.pos.y += dy / baseRect.h;
      this.clampTextLayerToZone(layer);
    }
    this.render();
  }

  clampToZone(pos) {
    if (!this.state.zoneArea) return;
    const z = this.state.zoneArea;
    pos.x = Math.min(z.x + z.w, Math.max(z.x, pos.x));
    pos.y = Math.min(z.y + z.h, Math.max(z.y, pos.y));
  }

  clampBoxToZone(pos, boxW, boxH) {
    if (!this.state.zoneArea) return;
    const z = this.state.zoneArea;
    const halfW = boxW / 2;
    const halfH = boxH / 2;
    const minX = z.x + halfW;
    const maxX = z.x + z.w - halfW;
    const minY = z.y + halfH;
    const maxY = z.y + z.h - halfH;

    pos.x = minX <= maxX ? Math.min(maxX, Math.max(minX, pos.x)) : z.x + z.w / 2;
    pos.y = minY <= maxY ? Math.min(maxY, Math.max(minY, pos.y)) : z.y + z.h / 2;
  }

  clampImageLayerToZone(layer) {
    if (!layer) return;
    if (this.state.zoneArea) {
      const ratio = layer.image?.naturalWidth && layer.image?.naturalHeight
        ? layer.image.naturalHeight / layer.image.naturalWidth
        : (layer.size.w ? layer.size.h / layer.size.w : 1);

      const maxScale = Math.min(
        this.state.zoneArea.w / Math.max(layer.size.w, 0.0001),
        this.state.zoneArea.h / Math.max(layer.size.h, 0.0001)
      );

      if (maxScale < 1) {
        layer.size.w *= maxScale;
        layer.size.h *= maxScale;
      }

      if (layer.size.w > this.state.zoneArea.w) {
        layer.size.w = this.state.zoneArea.w;
        layer.size.h = layer.size.w * ratio;
      }

      if (layer.size.h > this.state.zoneArea.h) {
        layer.size.h = this.state.zoneArea.h;
        layer.size.w = ratio ? layer.size.h / ratio : layer.size.w;
      }
    }
    this.clampBoxToZone(layer.pos, layer.size.w, layer.size.h);
  }

  getTextLayerSizeInBaseUnits(layer) {
    const baseRect = this.getBaseRect();
    if (!baseRect || !layer) return null;
    this.ctx.font = `${layer.size || this.state.textSize || 28}px ${layer.font || this.state.textFont || "sans-serif"}`;
    const lines = this.getTextLines(layer.value || " ");
    const baseW = Math.max(
      1,
      ...lines.map((line) => this.ctx.measureText(line || " ").width || 1)
    );
    const baseH = (layer.size || this.state.textSize || 28) * Math.max(1, lines.length) * 1.2;
    return {
      w: (baseW * layer.scale) / baseRect.w,
      h: (baseH * layer.scale) / baseRect.h
    };
  }

  clampTextLayerToZone(layer) {
    if (!layer) return;
    const size = this.getTextLayerSizeInBaseUnits(layer);
    if (!size) return;
    if (this.state.zoneArea) {
      const scaleLimitW = size.w > 0 ? this.state.zoneArea.w / size.w : 1;
      const scaleLimitH = size.h > 0 ? this.state.zoneArea.h / size.h : 1;
      const scaleLimit = Math.min(scaleLimitW, scaleLimitH);
      if (scaleLimit < 1) {
        layer.scale = Math.max(0.2, layer.scale * scaleLimit);
      }
    }
    const nextSize = this.getTextLayerSizeInBaseUnits(layer);
    if (!nextSize) return;
    this.clampBoxToZone(layer.pos, nextSize.w, nextSize.h);
  }

  getBaseRect() {
    if (!this.baseImage || !this.baseImage.naturalWidth) return null;
    const cw = this.canvas.width;
    const ch = this.canvas.height;
    const iw = this.baseImage.naturalWidth;
    const ih = this.baseImage.naturalHeight;
    const scale = Math.min(cw / iw, ch / ih);
    const w = iw * scale;
    const h = ih * scale;
    const x = (cw - w) / 2;
    const y = (ch - h) / 2;
    return { x, y, w, h };
  }

  getZoneRect(baseRect) {
    if (!baseRect || !this.state.zoneArea) return null;
    const z = this.state.zoneArea;
    return {
      x: baseRect.x + baseRect.w * z.x,
      y: baseRect.y + baseRect.h * z.y,
      w: baseRect.w * z.w,
      h: baseRect.h * z.h
    };
  }

  getElementBounds(element) {
    const baseRect = this.getBaseRect();
    if (!baseRect) return null;
    const zone = this.getCurrentZoneState();
    if (!zone) return null;
    if (typeof element === "string" && element.startsWith("image:")) {
      const layer = this.getImageLayerByToken(element, zone);
      if (!layer?.image) return null;
      const w = baseRect.w * layer.size.w;
      const h = baseRect.h * layer.size.h;
      const x = baseRect.x + baseRect.w * layer.pos.x - w / 2;
      const y = baseRect.y + baseRect.h * layer.pos.y - h / 2;
      return { x, y, w, h };
    }
    if (typeof element === "string" && element.startsWith("text:")) {
      const layer = this.getTextLayerByToken(element, zone);
      if (!layer) return null;
      this.ctx.font = `${layer.size || this.state.textSize || 28}px ${layer.font || this.state.textFont || "sans-serif"}`;
      const lines = this.getTextLines(layer.value || " ");
      const baseW = Math.max(
        1,
        ...lines.map((line) => this.ctx.measureText(line || " ").width || 1)
      );
      const baseH = (layer.size || this.state.textSize || 28) * Math.max(1, lines.length) * 1.2;
      const w = baseW * layer.scale;
      const h = baseH * layer.scale;
      const x = baseRect.x + baseRect.w * layer.pos.x - w / 2;
      const y = baseRect.y + baseRect.h * layer.pos.y - h / 2;
      return { x, y, w, h, pad: 6 };
    }
    return null;
  }

  render() {
    const ctx = this.ctx;
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    const baseRect = this.getBaseRect();
    if (!baseRect || !this.baseImage) return;

    ctx.drawImage(this.baseImage, baseRect.x, baseRect.y, baseRect.w, baseRect.h);

    const zoneRect = this.getZoneRect(baseRect);
    if (zoneRect) {
      ctx.save();
      ctx.setLineDash([8, 6]);
      ctx.strokeStyle = "#c4c4c4";
      ctx.lineWidth = 2;
      ctx.strokeRect(zoneRect.x, zoneRect.y, zoneRect.w, zoneRect.h);
      ctx.restore();
    }

    const zone = this.getCurrentZoneState();
    if (this.worldCupMode && zone) {
      this.drawWorldCupElements(ctx, baseRect, zone);
      return;
    }

    if (zone) {
      this.getZoneImageLayers(zone).forEach((layer) => {
        const token = `image:${layer.id}`;
        const bounds = this.getElementBounds(token);
        if (!bounds || !layer.image) return;
        ctx.drawImage(layer.image, bounds.x, bounds.y, bounds.w, bounds.h);
        if (this.selected === token) this.drawSelection(bounds);
      });

      this.getZoneTextLayers(zone).forEach((layer) => {
        const token = `text:${layer.id}`;
        const bounds = this.getElementBounds(token);
        if (!bounds) return;
        const lines = this.getTextLines(layer.value || "");
        const fontSize = layer.size || this.state.textSize || 28;
        const lineHeight = fontSize * 1.2;
        ctx.save();
        ctx.translate(bounds.x + bounds.w / 2, bounds.y + bounds.h / 2);
        ctx.scale(layer.scale, layer.scale);
        ctx.fillStyle = layer.color || this.state.textColor;
        ctx.font = `${fontSize}px ${layer.font || this.state.textFont || "sans-serif"}`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        const startY = -((lines.length - 1) * lineHeight) / 2;
        lines.forEach((line, index) => {
          ctx.fillText(line, 0, startY + index * lineHeight);
        });
        ctx.restore();
        if (this.selected === token) this.drawSelection(bounds);
      });
    }
  }

  drawWorldCupElements(ctx, baseRect, zone) {
    const layout = this.getWorldCupLayout(zone.key);
    if (!layout) return;
    const visibility = this.getWorldCupVisibility(zone.key);
    const country = this.getWorldCupCountry(zone.worldCup?.country);
    const worldCupTextColor =
      this.getCurrentVariantWorldCupTextColor() ||
      this.normalizeHexColor(country?.text_color) ||
      "#ffffff";
    if (visibility.country && country?.crest && layout.crest) {
      const crest = this.getCachedImage(country.crest);
      if (crest?.complete) {
        const width = baseRect.w * ((Number(layout.crest.w) || 18) / 100);
        const height = crest.naturalWidth ? width * (crest.naturalHeight / crest.naturalWidth) : width;
        const x = baseRect.x + baseRect.w * ((Number(layout.crest.x) || 50) / 100) - width / 2;
        const y = baseRect.y + baseRect.h * ((Number(layout.crest.y) || 30) / 100) - height / 2;
        ctx.drawImage(crest, x, y, width, height);
      }
    }

    const worldCupFontFamily = this.worldCupConfig?.text?.font_family || "Anton";
    const drawLockedText = (value, config) => {
      if (!String(value || "").trim() || !config) return;
      const fontSize = baseRect.w * ((Number(config.size) || 8) / 100);
      ctx.save();
      ctx.fillStyle = worldCupTextColor;
      ctx.font = `700 ${fontSize}px "${worldCupFontFamily}", sans-serif`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(String(value), baseRect.x + baseRect.w * ((Number(config.x) || 50) / 100), baseRect.y + baseRect.h * ((Number(config.y) || 50) / 100));
      ctx.restore();
    };

    if (visibility.name) drawLockedText(zone.worldCup?.name, layout.name);
    if (visibility.number) drawLockedText(zone.worldCup?.number, layout.number);
  }

  drawSelection(bounds) {
    const ctx = this.ctx;
    const size = this.getHandleVisualSize();
    ctx.save();
    ctx.strokeStyle = "#2b6fff";
    ctx.lineWidth = 1.5;
    ctx.strokeRect(bounds.x, bounds.y, bounds.w, bounds.h);
    ctx.fillStyle = "#ffffff";
    ctx.strokeStyle = "#2b6fff";
    this.getHandlePoints(bounds).forEach((p) => {
      ctx.fillRect(p.x - size / 2, p.y - size / 2, size, size);
      ctx.strokeRect(p.x - size / 2, p.y - size / 2, size, size);
    });
    ctx.restore();
  }

  getCanvasUnit(px) {
    const rect = this.canvas?.getBoundingClientRect();
    if (!rect?.width) return px;
    return px * (this.canvas.width / rect.width);
  }

  getHandleVisualSize() {
    return this.getCanvasUnit(12);
  }

  getHandleHitSize(bounds = null) {
    return this.getCanvasUnit(28);
  }

  getHandlePoints(bounds) {
    const offset = this.getCanvasUnit(14);
    return [
      { id: "nw", x: bounds.x - offset, y: bounds.y - offset },
      { id: "ne", x: bounds.x + bounds.w + offset, y: bounds.y - offset },
      { id: "sw", x: bounds.x - offset, y: bounds.y + bounds.h + offset },
      { id: "se", x: bounds.x + bounds.w + offset, y: bounds.y + bounds.h + offset }
    ];
  }

  getHandleBoxes(bounds) {
    const hitSize = this.getHandleHitSize();
    return this.getHandlePoints(bounds).map((point) => ({
      id: point.id,
      x: point.x - hitSize / 2,
      y: point.y - hitSize / 2,
      w: hitSize,
      h: hitSize,
      cx: point.x,
      cy: point.y
    }));
  }

  hitTestHandle(pos) {
    if (!this.selected) return null;
    const bounds = this.getElementBounds(this.selected);
    if (!bounds) return null;
    const boxes = this.getHandleBoxes(bounds);

    const hit = boxes.find((box) => (
      pos.x >= box.x &&
      pos.x <= box.x + box.w &&
      pos.y >= box.y &&
      pos.y <= box.y + box.h
    ));

    if (!hit) return null;
    return { target: this.selected, handle: hit.id };
  }

  getResizeHandleFromPosition(bounds, pos) {
    const centerX = bounds.x + bounds.w / 2;
    const centerY = bounds.y + bounds.h / 2;
    const horizontal = pos.x < centerX ? "w" : "e";
    const vertical = pos.y < centerY ? "n" : "s";
    return `${vertical}${horizontal}`;
  }

  hitTestAnyHandle(pos) {
    const zone = this.getCurrentZoneState();
    if (!zone) return null;
    const elements = [];
    this.getZoneImageLayers(zone).forEach((layer) => elements.push(`image:${layer.id}`));
    this.getZoneTextLayers(zone).forEach((layer) => elements.push(`text:${layer.id}`));
    for (let i = elements.length - 1; i >= 0; i -= 1) {
      const target = elements[i];
      const bounds = this.getElementBounds(target);
      if (!bounds) continue;
      const boxes = this.getHandleBoxes(bounds);
      const hit = boxes.find((box) => (
        pos.x >= box.x &&
        pos.x <= box.x + box.w &&
        pos.y >= box.y &&
        pos.y <= box.y + box.h
      ));
      if (hit) return { target, handle: hit.id };
    }
    return null;
  }

  hitTestAnyResize(pos) {
    const zone = this.getCurrentZoneState();
    if (!zone) return null;
    const elements = [];
    this.getZoneImageLayers(zone).forEach((layer) => elements.push(`image:${layer.id}`));
    this.getZoneTextLayers(zone).forEach((layer) => elements.push(`text:${layer.id}`));
    for (let i = elements.length - 1; i >= 0; i -= 1) {
      const target = elements[i];
      const bounds = this.getElementBounds(target);
      if (!bounds) continue;

      const outerPad = this.getCanvasUnit(18);
      const innerInset = Math.min(this.getCanvasUnit(12), Math.max(this.getCanvasUnit(4), Math.min(bounds.w, bounds.h) * 0.2));

      const withinOuter =
        pos.x >= bounds.x - outerPad &&
        pos.x <= bounds.x + bounds.w + outerPad &&
        pos.y >= bounds.y - outerPad &&
        pos.y <= bounds.y + bounds.h + outerPad;

      const withinInner =
        pos.x >= bounds.x + innerInset &&
        pos.x <= bounds.x + bounds.w - innerInset &&
        pos.y >= bounds.y + innerInset &&
        pos.y <= bounds.y + bounds.h - innerInset;

      if (!withinOuter || withinInner) continue;
      return { target, handle: this.getResizeHandleFromPosition(bounds, pos) };
    }
    return null;
  }

  hitTestSelectedResize(pos) {
    if (!this.selected) return null;
    const bounds = this.getElementBounds(this.selected);
    if (!bounds) return null;

    const outerPad = this.getCanvasUnit(18);
    const innerInset = Math.min(this.getCanvasUnit(12), Math.max(this.getCanvasUnit(4), Math.min(bounds.w, bounds.h) * 0.2));

    const withinOuter =
      pos.x >= bounds.x - outerPad &&
      pos.x <= bounds.x + bounds.w + outerPad &&
      pos.y >= bounds.y - outerPad &&
      pos.y <= bounds.y + bounds.h + outerPad;

    const withinInner =
      pos.x >= bounds.x + innerInset &&
      pos.x <= bounds.x + bounds.w - innerInset &&
      pos.y >= bounds.y + innerInset &&
      pos.y <= bounds.y + bounds.h - innerInset;

    if (!withinOuter || withinInner) return null;
    return { target: this.selected, handle: this.getResizeHandleFromPosition(bounds, pos) };
  }

  resizeElement(element, handle, dx, dy) {
    const baseRect = this.getBaseRect();
    const bounds = this.getElementBounds(element);
    if (!baseRect || !bounds) return;
    const centerX = bounds.x + bounds.w / 2;
    const centerY = bounds.y + bounds.h / 2;
    const handlePoint = this.getHandlePoints(bounds).find((point) => point.id === handle);
    if (!handlePoint) return;

    const startVecX = handlePoint.x - centerX;
    const startVecY = handlePoint.y - centerY;
    const nextVecX = startVecX + dx;
    const nextVecY = startVecY + dy;
    const startDistance = Math.hypot(startVecX, startVecY) || 1;
    const nextDistance = Math.hypot(nextVecX, nextVecY);
    const scale = Math.max(0.2, nextDistance / startDistance);

    const w = Math.max(20, bounds.w * scale);
    const h = Math.max(20, bounds.h * scale);

    const zone = this.getCurrentZoneState();
    if (!zone) return;
    if (typeof element === "string" && element.startsWith("image:")) {
      const layer = this.getImageLayerByToken(element, zone);
      if (!layer) return;
      layer.pos.x = (centerX - baseRect.x) / baseRect.w;
      layer.pos.y = (centerY - baseRect.y) / baseRect.h;
      layer.size.w = w / baseRect.w;
      layer.size.h = h / baseRect.h;
      this.clampImageLayerToZone(layer);
    } else if (typeof element === "string" && element.startsWith("text:")) {
      const layer = this.getTextLayerByToken(element, zone);
      if (!layer) return;
      layer.pos.x = (centerX - baseRect.x) / baseRect.w;
      layer.pos.y = (centerY - baseRect.y) / baseRect.h;
      layer.scale = Math.max(0.2, layer.scale * scale);
      this.clampTextLayerToZone(layer);
    }

    this.render();
    this.syncHiddenFields();
  }

  syncHiddenFields() {
    this.hiddenFields.type.value = this.state.type || "";
    const zoneLabels = Array.from(this.zonesSelected.keys());
    const hasType = !!this.state.type;
    const hasZone = this.zonesSelected.size > 0;
    const isVisible = (mode) => {
      if (mode === "hide") return false;
      if (mode === "start") return true;
      if (mode === "type") return hasType;
      return hasZone;
    };

    this.setPropertyField(this.hiddenFields.type, isVisible(this.visibilityType) ? this.state.type || "" : "");
    this.setPropertyField(
      this.hiddenFields.zone,
      isVisible(this.visibilityZone)
        ? zoneLabels.map((label) => (this.enablePriceIncrement ? label : this.cleanZoneLabel(label))).join(", ")
        : ""
    );
    this.setPropertyField(this.hiddenFields.vinyl, isVisible(this.visibilityVinyl) ? this.state.vinylColor || "" : "");
    this.setPropertyField(this.hiddenFields.garment, this.garmentFieldEl && !this.garmentFieldEl.hidden ? this.state.garmentColor || "" : "");
    this.setPropertyField(this.hiddenFields.flag, this.flagFieldEl && !this.flagFieldEl.hidden && this.state.flag ? "Sí" : "");
    this.setPropertyField(this.hiddenFields.name, this.nameFieldEl && !this.nameFieldEl.hidden ? this.state.name || "" : "");
    this.setPropertyField(this.hiddenFields.number, this.numberFieldEl && !this.numberFieldEl.hidden ? this.state.number || "" : "");
    this.setPropertyField(this.hiddenFields.yearDad, this.yearDadFieldEl && !this.yearDadFieldEl.hidden ? this.state.yearDad || "" : "");
    this.setPropertyField(this.hiddenFields.yearBaby, this.yearBabyFieldEl && !this.yearBabyFieldEl.hidden ? this.state.yearBaby || "" : "");
    this.setPropertyField(this.hiddenFields.yearMom, this.yearMomFieldEl && !this.yearMomFieldEl.hidden ? this.state.yearMom || "" : "");
    this.setPropertyField(this.hiddenFields.playerName, this.playerNameFieldEl && !this.playerNameFieldEl.hidden ? this.state.playerName || "" : "");
    this.setPropertyField(this.hiddenFields.dadName, this.dadNameFieldEl && !this.dadNameFieldEl.hidden ? this.state.dadName || "" : "");
    this.setPropertyField(this.hiddenFields.momName, this.momNameFieldEl && !this.momNameFieldEl.hidden ? this.state.momName || "" : "");
    this.setPropertyField(this.hiddenFields.childName, this.childNameFieldEl && !this.childNameFieldEl.hidden ? this.state.childName || "" : "");
    this.setPropertyField(this.hiddenFields.dadNumber, this.dadNumberFieldEl && !this.dadNumberFieldEl.hidden ? this.state.dadNumber || "" : "");
    this.setPropertyField(this.hiddenFields.momNumber, this.momNumberFieldEl && !this.momNumberFieldEl.hidden ? this.state.momNumber || "" : "");
    this.setPropertyField(this.hiddenFields.childNumber, this.childNumberFieldEl && !this.childNumberFieldEl.hidden ? this.state.childNumber || "" : "");
    this.setPropertyField(this.hiddenFields.variantTitle, "");
    this.setPropertyField(this.hiddenFields.variantId, "");
    const total = this.computeTotalPrice();
    this.setPropertyField(this.hiddenFields.total, this.shouldHandleSurcharge() && !this.worldCupMode && total.value > 0 ? total.formatted : "");
    if (this.totalEl) {
      if (total.value > 0) {
        this.totalEl.hidden = false;
        this.totalEl.textContent = `Total personalización: +${total.formatted}`;
      } else {
        this.totalEl.hidden = true;
      }
    }
    this.updateDisplayedPrices(total.value);
    this.updateZoneSummary();
  }

  setPropertyField(field, value) {
    if (!field) return;
    const normalized = String(value || "").trim();
    field.value = normalized;
    field.disabled = normalized.length === 0;
  }

  shouldHandleSurcharge() {
    return this.chargePersonalizationFee && (this.enablePriceIncrement || this.enableMultiZoneSurcharge);
  }

  updateZoneSummary() {
    if (!this.zoneSummaryEl) return;
    const labels = Array.from(this.zonesSelected.keys())
      .map((label) => this.cleanZoneLabel(label))
      .filter(Boolean);
    if (!labels.length) {
      this.zoneSummaryEl.hidden = true;
      this.zoneSummaryEl.textContent = "";
      return;
    }
    this.zoneSummaryEl.hidden = false;
    this.zoneSummaryEl.textContent = labels.length === 1 ? `Zona seleccionada: ${labels[0]}` : `Zonas seleccionadas: ${labels.join(", ")}`;
  }

  updateDisplayedPrices(customizationEuros) {
    const variant = this.currentVariant || {};
    const basePriceCents = Number(variant.price || 0);
    if (!basePriceCents) return;

    const compareAtCents = Number(variant.compare_at_price || 0);
    const extraCents = Math.round((Number(customizationEuros) || 0) * 100);
    const finalPriceCents = Math.max(0, basePriceCents + extraCents);
    const finalCompareAtCents = compareAtCents > 0 ? Math.max(finalPriceCents, compareAtCents + extraCents) : 0;

    const finalPriceText = this.formatMoneyCents(finalPriceCents);
    const finalCompareText = finalCompareAtCents > finalPriceCents ? this.formatMoneyCents(finalCompareAtCents) : "";

    this.sectionEl.querySelectorAll(".price .price__regular").forEach((el) => {
      el.textContent = finalPriceText;
    });

    this.sectionEl.querySelectorAll(".price .price__sale").forEach((el) => {
      if (finalCompareText) {
        el.textContent = finalCompareText;
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });

    // ATC button price lives in <product-buy-price>. Update it explicitly.
    this.sectionEl.querySelectorAll("product-buy-price").forEach((el) => {
      el.setAttribute("data-price", String(finalPriceCents));
      el.textContent = finalPriceText;
    });
  }

  formatMoneyCents(cents) {
    const value = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return `${value.toFixed(2).replace(".", ",")} €`;
    }
  }

  exportState() {
    return {
      type: this.state.type,
      vinylColor: this.state.vinylColor,
      garmentColor: this.state.garmentColor,
      flag: this.state.flag,
      name: this.state.name,
      number: this.state.number,
      yearDad: this.state.yearDad,
      yearBaby: this.state.yearBaby,
      yearMom: this.state.yearMom,
      playerName: this.state.playerName,
      dadName: this.state.dadName,
      momName: this.state.momName,
      childName: this.state.childName,
      dadNumber: this.state.dadNumber,
      momNumber: this.state.momNumber,
      childNumber: this.state.childNumber,
      textColor: this.state.textColor,
      textFont: this.state.textFont,
      textSize: this.state.textSize,
      zones: Array.from(this.zonesSelected.values()).map((zone) => ({
        label: zone.label,
        price: zone.price,
        area: zone.area,
        images: this.getZoneImageLayers(zone).map((layer) => ({
          pos: layer.pos,
          size: layer.size
        })),
        texts: this.getZoneTextLayers(zone).map((layer) => ({
          value: layer.value,
          pos: layer.pos,
          scale: layer.scale,
          color: layer.color,
          font: layer.font,
          size: layer.size
        })),
        image: this.getZoneImageLayers(zone).length > 0
      }))
    };
  }

  validate() {
    const errors = [];
    if (this.worldCupMode) {
      if (this.zonesSelected.size === 0) errors.push("Selecciona la zona de personalización.");
      const missingWorldCup = Array.from(this.zonesSelected.values()).some((zone) => {
        const visibility = this.getWorldCupVisibility(zone.key);
        if (visibility.country && !String(zone.worldCup?.country || "").trim()) return true;
        if (visibility.name && !String(zone.worldCup?.name || "").trim()) return true;
        if (visibility.number && !String(zone.worldCup?.number || "").trim()) return true;
        return false;
      });
      if (missingWorldCup) errors.push("Completa los campos requeridos en todas las zonas seleccionadas.");
      return errors;
    }
    if (this.requireType && !this.state.type) errors.push("Selecciona el tipo de personalización.");
    if (this.requireZone && this.zonesSelected.size === 0) errors.push("Selecciona la zona de personalización.");
    if (this.requireVinylColor && !this.state.vinylColor) errors.push("Selecciona el color de vinilo.");
    if (this.requireGarmentColor && !this.state.garmentColor) errors.push("Selecciona el color de prenda.");
    if (this.requireFlag && !this.state.flag) errors.push("Debes añadir la bandera de España.");
    if (this.requireOptionManga && this.variantOptionVisibility.manga !== false && !this.hasSelectedVariantOption("manga")) errors.push("Selecciona la manga.");
    if (this.requireOptionColor && this.variantOptionVisibility.color !== false && !this.hasSelectedVariantOption("color")) errors.push("Selecciona el color.");
    if (this.requireOptionTalla && this.variantOptionVisibility.talla !== false && !this.hasSelectedVariantOption("talla")) errors.push("Selecciona la talla.");
    if (this.requireName && this.nameFieldEl && !this.nameFieldEl.hidden && !String(this.state.name || "").trim()) errors.push(`Debes indicar el ${this.nameLabel.toLowerCase()}.`);
    if (this.requireNumber && this.numberFieldEl && !this.numberFieldEl.hidden && !String(this.state.number || "").trim()) errors.push(`Debes indicar el ${this.numberLabel.toLowerCase()}.`);
    if (this.requireYearDad && this.yearDadFieldEl && !this.yearDadFieldEl.hidden && !String(this.state.yearDad || "").trim()) errors.push(`Debes indicar el ${this.yearDadLabel.toLowerCase()}.`);
    if (this.requireYearBaby && this.yearBabyFieldEl && !this.yearBabyFieldEl.hidden && !String(this.state.yearBaby || "").trim()) errors.push(`Debes indicar el ${this.yearBabyLabel.toLowerCase()}.`);
    if (this.requireYearMom && this.yearMomFieldEl && !this.yearMomFieldEl.hidden && !String(this.state.yearMom || "").trim()) errors.push(`Debes indicar el ${this.yearMomLabel.toLowerCase()}.`);
    if (this.requirePlayerName && this.playerNameFieldEl && !this.playerNameFieldEl.hidden && !String(this.state.playerName || "").trim()) errors.push(`Debes indicar el ${this.playerNameLabel.toLowerCase()}.`);
    if (this.requireDadName && this.dadNameFieldEl && !this.dadNameFieldEl.hidden && !String(this.state.dadName || "").trim()) errors.push(`Debes indicar el ${this.dadNameLabel.toLowerCase()}.`);
    if (this.requireMomName && this.momNameFieldEl && !this.momNameFieldEl.hidden && !String(this.state.momName || "").trim()) errors.push(`Debes indicar el ${this.momNameLabel.toLowerCase()}.`);
    if (this.requireChildName && this.childNameFieldEl && !this.childNameFieldEl.hidden && !String(this.state.childName || "").trim()) errors.push(`Debes indicar el ${this.childNameLabel.toLowerCase()}.`);
    if (this.requireDadNumber && this.dadNumberFieldEl && !this.dadNumberFieldEl.hidden && !String(this.state.dadNumber || "").trim()) errors.push(`Debes indicar el ${this.dadNumberLabel.toLowerCase()}.`);
    if (this.requireMomNumber && this.momNumberFieldEl && !this.momNumberFieldEl.hidden && !String(this.state.momNumber || "").trim()) errors.push(`Debes indicar el ${this.momNumberLabel.toLowerCase()}.`);
    if (this.requireChildNumber && this.childNumberFieldEl && !this.childNumberFieldEl.hidden && !String(this.state.childNumber || "").trim()) errors.push(`Debes indicar el ${this.childNumberLabel.toLowerCase()}.`);
    if (this.requireDesign) {
      const missing = Array.from(this.zonesSelected.values()).some((zone) => {
        const hasText = this.getZoneTextLayers(zone).some((layer) => String(layer.value || "").trim());
        return !this.getZoneImageLayers(zone).length && !hasText;
      });
      if (missing) errors.push("Añade un diseño o texto en todas las zonas seleccionadas.");
    }
    return errors;
  }

  bindForm() {
    if (!this.form) return;
    this.form.addEventListener(
      "submit",
      async (event) => {
        if (this.form.dataset.customizerSubmitting === "true") {
          this.form.dataset.customizerSubmitting = "";
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        const errors = this.validate();
        if (errors.length) {
          this.showErrors(errors);
          return;
        }

        this.hideErrors();
        this.syncHiddenFields();
        await this.generateRenderFiles();
        await this.ensureAddonForCurrentSelection();
        this.form.dataset.customizerSubmitting = "true";
        this.form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
      },
      true
    );
  }

  showErrors(errors) {
    if (!this.errorsEl) return;
    this.errorsEl.hidden = false;
    this.errorsEl.innerHTML = errors.map((e) => `<div>${e}</div>`).join("");
  }

  hideErrors() {
    if (!this.errorsEl) return;
    this.errorsEl.hidden = true;
    this.errorsEl.innerHTML = "";
  }

  async generateRenderFiles() {
    if (!this.baseImage || !this.baseImage.naturalWidth) return;
    if (!this.filesEl) return;
    this.filesEl.innerHTML = "";
    const zones = Array.from(this.zonesSelected.values());
    for (const zone of zones) {
      const cleanLabel = this.cleanZoneLabel(zone.label);
      if (this.worldCupMode) {
        const visibility = this.getWorldCupVisibility(zone.key);
        if (visibility.country) {
          const countryInput = document.createElement("input");
          countryInput.type = "hidden";
          countryInput.name = `properties[País - ${cleanLabel}]`;
          countryInput.setAttribute("form", this.formId);
          countryInput.value = this.getWorldCupCountry(zone.worldCup?.country)?.label || zone.worldCup?.country || "";
          this.filesEl.appendChild(countryInput);
        }

        if (visibility.name) {
          const nameInput = document.createElement("input");
          nameInput.type = "hidden";
          nameInput.name = `properties[Nombre - ${cleanLabel}]`;
          nameInput.setAttribute("form", this.formId);
          nameInput.value = zone.worldCup?.name || "";
          this.filesEl.appendChild(nameInput);
        }

        if (visibility.number) {
          const numberInput = document.createElement("input");
          numberInput.type = "hidden";
          numberInput.name = `properties[Número - ${cleanLabel}]`;
          numberInput.setAttribute("form", this.formId);
          numberInput.value = zone.worldCup?.number || "";
          this.filesEl.appendChild(numberInput);
        }
      }

      const zoneTextValue = this.serializeZoneTexts(zone);
      if (zoneTextValue && !this.worldCupMode) {
        const textInput = document.createElement("input");
        textInput.type = "hidden";
        textInput.name = `properties[Texto - ${cleanLabel}]`;
        textInput.setAttribute("form", this.formId);
        textInput.value = zoneTextValue;
        this.filesEl.appendChild(textInput);
      }

      const file = await this.renderZoneToFile(zone);
      if (!file) continue;
      const input = document.createElement("input");
      input.type = "file";
      input.name = `properties[Diseño personalizado - ${cleanLabel}]`;
      input.setAttribute("form", this.formId);
      input.hidden = true;
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      input.files = dataTransfer.files;
      this.filesEl.appendChild(input);

      const uploadedLayers = this.getZoneImageLayers(zone).filter((layer) => layer?.sourceFile instanceof File);
      uploadedLayers.forEach((layer, index) => {
        const uploadInput = document.createElement("input");
        uploadInput.type = "file";
        uploadInput.name = `properties[Imagen subida - ${cleanLabel} ${index + 1}]`;
        uploadInput.setAttribute("form", this.formId);
        uploadInput.hidden = true;
        const uploadTransfer = new DataTransfer();
        uploadTransfer.items.add(layer.sourceFile);
        uploadInput.files = uploadTransfer.files;
        this.filesEl.appendChild(uploadInput);
      });
    }
  }

  async renderZoneToFile(zone) {
    const exportCanvas = document.createElement("canvas");
    exportCanvas.width = this.baseImage.naturalWidth;
    exportCanvas.height = this.baseImage.naturalHeight;
    const ctx = exportCanvas.getContext("2d");
    const baseImage = this.getBaseImageForZone(zone) || this.baseImage;
    ctx.drawImage(baseImage, 0, 0, exportCanvas.width, exportCanvas.height);

    const baseRect = { x: 0, y: 0, w: exportCanvas.width, h: exportCanvas.height };
    const zoneArea = this.getZoneAreaForZone(zone);
    const zoneRect = zoneArea
      ? {
          x: baseRect.w * zoneArea.x,
          y: baseRect.h * zoneArea.y,
          w: baseRect.w * zoneArea.w,
          h: baseRect.h * zoneArea.h
        }
      : null;

    if (this.worldCupMode) {
      this.drawWorldCupElements(ctx, baseRect, zone);
    } else {
      this.getZoneImageLayers(zone).forEach((layer) => {
        if (!layer.image) return;
        const w = baseRect.w * layer.size.w;
        const h = baseRect.h * layer.size.h;
        const x = baseRect.x + baseRect.w * layer.pos.x - w / 2;
        const y = baseRect.y + baseRect.h * layer.pos.y - h / 2;
        ctx.drawImage(layer.image, x, y, w, h);
      });

      this.getZoneTextLayers(zone).forEach((layer) => {
        if (!String(layer.value || "").trim()) return;
        const fontSize = Math.round((layer.size || this.state.textSize || 28) * (exportCanvas.width / this.canvas.width));
        const lineHeight = fontSize * 1.2;
        const lines = this.getTextLines(layer.value);
        ctx.fillStyle = layer.color || this.state.textColor;
        ctx.font = `${fontSize}px ${layer.font || this.state.textFont || "sans-serif"}`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.save();
        ctx.translate(baseRect.w * layer.pos.x, baseRect.h * layer.pos.y);
        ctx.scale(layer.scale, layer.scale);
        const startY = -((lines.length - 1) * lineHeight) / 2;
        lines.forEach((line, index) => {
          ctx.fillText(line, 0, startY + index * lineHeight);
        });
        ctx.restore();
      });
    }

    if (zoneRect) {
      ctx.strokeStyle = "rgba(0,0,0,0)";
      ctx.strokeRect(zoneRect.x, zoneRect.y, zoneRect.w, zoneRect.h);
    }

    const blob = await new Promise((resolve) => exportCanvas.toBlob(resolve, "image/png", 0.95));
    if (!blob) return null;
    return new File([blob], `personalizacion-${Date.now()}-${this.safeSlug(zone.label)}.png`, { type: "image/png" });
  }

  safeSlug(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 40);
  }

  cleanZoneLabel(label) {
    return String(label || "")
      .replace(/\s*\(\+\s*[\d.,]+\s*€\)\s*/gi, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  serializeZoneTexts(zone) {
    return this.getZoneTextLayers(zone)
      .map((layer) => String(layer.value || "").trim())
      .filter(Boolean)
      .map((value) => value.split(/\r?\n/).map((line) => line.trim()).filter(Boolean).join(" / "))
      .join(" | ");
  }

  computeTotalPrice() {
    if (this.worldCupMode || !this.shouldHandleSurcharge()) {
      return { value: 0, formatted: this.formatPrice(0) };
    }

    let total = 0;
    for (const zone of this.zonesSelected.values()) {
      total += this.parsePrice(zone.price);
    }
    if (this.enableMultiZoneSurcharge) {
      const personalizedZones = this.countPersonalizedZones();
      if (personalizedZones >= this.multiZoneSurchargeThreshold) {
        total += this.multiZoneSurchargeAmount;
      }
    }
    const hasMultiZonePersonalization = this.enableMultiZoneSurcharge && this.zonesSelected.size >= 2;
    if (hasMultiZonePersonalization && total < 5) {
      total = 5;
    }
    return { value: total, formatted: this.formatPrice(total) };
  }

  normalizeZonePricingMode() {
    if (!this.enableMultiZoneSurcharge) return;
    const normalize = (zones) =>
      (Array.isArray(zones) ? zones : []).map((zone) => ({
        ...zone,
        label: this.cleanZoneLabel(zone.label),
        price: ""
      }));

    this.zonesVinyl = normalize(this.zonesVinyl);
    this.zonesBordado = normalize(this.zonesBordado);
    this.zones = this.state?.type === this.bordadoLabel ? this.zonesBordado : this.zonesVinyl;
  }

  countPersonalizedZones() {
    let count = 0;
    for (const zone of this.zonesSelected.values()) {
      if (this.isZonePersonalized(zone)) count += 1;
    }
    return count;
  }

  isZonePersonalized(zone) {
    if (!zone) return false;
    if (this.worldCupMode) {
      const visibility = this.getWorldCupVisibility(zone.key);
      if (visibility.country && String(zone.worldCup?.country || "").trim()) return true;
      if (visibility.name && String(zone.worldCup?.name || "").trim()) return true;
      if (visibility.number && String(zone.worldCup?.number || "").trim()) return true;
      return false;
    }
    const hasImage = this.getZoneImageLayers(zone).length > 0;
    const hasText = this.getZoneTextLayers(zone).some((layer) => String(layer.value || "").trim());
    return hasImage || hasText;
  }

  parsePrice(value) {
    if (!value) return 0;
    const cleaned = String(value)
      .replace(/[^0-9,.-]/g, "")
      .replace(",", ".");
    const num = parseFloat(cleaned);
    return Number.isNaN(num) ? 0 : num;
  }

  formatPrice(value) {
    const rounded = Math.round(value * 100) / 100;
    return `${rounded.toFixed(2).replace(".", ",")} €`;
  }

  removePriceFromLabel(value) {
    return String(value || "")
      .replace(/\s*\(\+\s*[\d.,]+\s*€\)\s*/gi, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  bindAddonSync() {
    if (!this.shouldHandleSurcharge()) return;
    this.addonSyncTimer = null;
    const scheduleSync = () => {
      if (this.addonSyncTimer) clearTimeout(this.addonSyncTimer);
      this.addonSyncTimer = setTimeout(() => this.fetchCartAndSync(), 120);
    };

    const onCartChange = (event) => {
      if (this.addonSyncing) return;
      const cart = event?.detail?.cart;
      if (cart && Array.isArray(cart.items)) {
        this.syncPersonalizationAddon(cart);
        scheduleSync();
        return;
      }
      scheduleSync();
    };

    document.addEventListener("cart:change", onCartChange);
    document.documentElement.addEventListener("cart:change", onCartChange);
    document.addEventListener("cart:updated", onCartChange);
    document.documentElement.addEventListener("cart:updated", onCartChange);
    document.addEventListener("cart:refresh", () => scheduleSync());
    document.documentElement.addEventListener("cart:refresh", () => scheduleSync());
    if (window.theme?.pubsub?.subscribe && window.theme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
      window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, onCartChange);
    }
    document.addEventListener("ajaxProduct:added", () => {
      scheduleSync();
      setTimeout(() => scheduleSync(), 500);
      setTimeout(() => scheduleSync(), 1400);
    });
    this.fetchCartAndSync();
  }

  async fetchCartAndSync() {
    if (this.addonSyncing) return;
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return;
      const cart = await res.json();
      await this.syncPersonalizationAddon(cart);
      const freshRes = await fetch("/cart.js", { credentials: "same-origin" });
      if (freshRes.ok) {
        const freshCart = await freshRes.json();
        if (window.theme?.pubsub?.publish && window.theme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
          window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            source: "product-customizer",
            cart: freshCart
          });
        }
      }
    } catch (e) {
      // ignore
    }
  }

  async syncPersonalizationAddon(cart) {
    if (!cart || !cart.items) return;
    if (!this.addonHandle) return;

    const { totalCents, hasPersonalization } = this.computeCartPersonalizationTotal(cart);
    const addonItem = cart.items.find((item) => {
      const byProperty = item.properties && item.properties._personalization_addon === "true";
      const byVariantId = Number(item.variant_id) === Number(this.forcedAddonVariantId);
      return byProperty || byVariantId;
    });

    if (!hasPersonalization || totalCents <= 0) {
      if (addonItem) {
        await this.updateCartItem(addonItem.key, 0);
      }
      return;
    }

    const addonVariant = await this.getAddonVariant();
    if (!addonVariant || !addonVariant.id) return;

    // JMG-style model: personalization addon is priced per 1€.
    const qty = Math.max(1, Math.round(totalCents / 100));
    if (qty <= 0) return;

    if (addonItem) {
      if (addonItem.variant_id === addonVariant.id && addonItem.quantity === qty) return;
      await this.updateCartItem(addonItem.key, qty);
      return;
    }
    await this.addAddonItem(addonVariant.id, totalCents, qty);
  }

  async ensureAddonForCurrentSelection() {
    if (!this.shouldHandleSurcharge()) return;
    const total = this.computeTotalPrice();
    if (!total || total.value <= 0) return;

    const addonVariant = await this.getAddonVariant();
    if (!addonVariant || !addonVariant.id) return;
    const quantity = Math.max(1, Math.round(total.value));
    this.addonSyncing = true;
    try {
      const cartRes = await fetch("/cart.js", { credentials: "same-origin" });
      if (cartRes.ok) {
        const cart = await cartRes.json();
        const existing = (cart.items || []).find((item) => {
          const byProperty = item.properties && item.properties._personalization_addon === "true";
          const byVariantId = Number(item.variant_id) === Number(this.forcedAddonVariantId);
          return byProperty || byVariantId;
        });
        if (existing) {
          const desiredQty = quantity;
          if (existing.variant_id === addonVariant.id && existing.quantity === desiredQty) return;
          await this.updateCartItem(existing.key, desiredQty);
          return;
        }
      }

      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          items: [
            {
              id: addonVariant.id,
              quantity,
              properties: {
                _personalization_addon: "true",
                "Total personalización": this.formatPrice(total.value)
              }
            }
          ]
        })
      });
    } catch (e) {
      // ignore
    } finally {
      this.addonSyncing = false;
    }
  }

  computeCartPersonalizationTotal(cart) {
    let totalCents = 0;
    let hasPersonalization = false;
    for (const item of cart.items) {
      const isAddonByProperty = item.properties && item.properties._personalization_addon === "true";
      const isAddonByVariantId = Number(item.variant_id) === Number(this.forcedAddonVariantId);
      if (isAddonByProperty || isAddonByVariantId) continue;
      const raw = item.properties ? item.properties["Total personalización"] : null;
      const zoneValue = item.properties ? item.properties["Zona de personalización"] : null;
      if (!raw && !zoneValue) continue;

      const rawEuros = raw ? this.parsePrice(raw) : 0;
      if (rawEuros > 0) {
        hasPersonalization = true;
        totalCents += Math.round(rawEuros * 100) * (item.quantity || 1);
        continue;
      }

      const zonesCount = this.countZonesFromProperty(zoneValue);
      if (zonesCount < 2) continue;

      hasPersonalization = true;
      totalCents += 500 * (item.quantity || 1);
    }
    return { totalCents, hasPersonalization };
  }

  countZonesFromProperty(zoneValue) {
    if (!zoneValue) return 0;
    return String(zoneValue)
      .split(",")
      .map((part) => part.trim())
      .filter(Boolean).length;
  }

  async getAddonVariantId() {
    if (this.forcedAddonVariantId) return this.forcedAddonVariantId;
    if (this.addonVariantId) return this.addonVariantId;
    const product = await this.getAddonProduct();
    if (!product) return null;
    const variant = product.variants[0];
    return variant ? variant.id : null;
  }

  async getAddonVariant() {
    if (this.forcedAddonVariantId) {
      return { id: Number(this.forcedAddonVariantId), price: 100 };
    }
    if (this.addonVariantId) {
      return { id: Number(this.addonVariantId), price: 100 };
    }
    const product = await this.getAddonProduct();
    if (!product) return null;
    const firstAvailable = (product.variants || []).find((v) => v.available);
    return firstAvailable || (product.variants || [])[0] || null;
  }

  async getAddonProduct() {
    if (this.addonProduct) return this.addonProduct;
    try {
      const res = await fetch(`/products/${this.addonHandle}.js`, { credentials: "same-origin" });
      if (!res.ok) return null;
      const product = await res.json();
      this.addonProduct = product;
      return product;
    } catch (e) {
      return null;
    }
  }

  async addAddonItem(variantId, totalCents, quantity) {
    this.addonSyncing = true;
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity,
              properties: {
                _personalization_addon: "true",
                "Total personalización": this.formatPrice(totalCents / 100)
              }
            }
          ]
        })
      });
      if (!response.ok) {
        const errText = await response.text();
        console.error("Addon add failed", { variantId, quantity, status: response.status, errText });
        return;
      }
      const cartRes = await fetch("/cart.js", { credentials: "same-origin" });
      if (cartRes.ok && window.theme?.pubsub?.publish && window.theme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
        const cartJson = await cartRes.json();
        window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: "product-customizer",
          cart: cartJson
        });
      }
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));
    } finally {
      this.addonSyncing = false;
    }
  }

  async updateCartItem(key, quantity) {
    this.addonSyncing = true;
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ id: key, quantity })
      });
      if (!response.ok) {
        const errText = await response.text();
        console.error("Addon change failed", { key, quantity, status: response.status, errText });
        return;
      }
      const cartRes = await fetch("/cart.js", { credentials: "same-origin" });
      if (cartRes.ok && window.theme?.pubsub?.publish && window.theme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
        const cartJson = await cartRes.json();
        window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: "product-customizer",
          cart: cartJson
        });
      }
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));
    } finally {
      this.addonSyncing = false;
    }
  }

  getCurrentZoneState() {
    if (!this.currentZone) return null;
    return this.zonesSelected.get(this.currentZone) || null;
  }

  createZoneState(item) {
    return {
      key: this.normalizeZoneKey(item.key || item.label),
      label: item.label,
      price: item.price || "",
      area: item.area || "",
      fallbackImageUrl: item.imageUrl || "",
      imageBaseUrl: this.getZoneBaseImageUrl(this.normalizeZoneKey(item.key || item.label), item.imageUrl),
      images: [],
      nextImageId: 0,
      texts: [],
      nextTextId: 0,
      worldCup: {
        country: "",
        name: "",
        number: ""
      }
    };
  }

  hasAnyVariantZoneImage(zoneKey) {
    if (!zoneKey || !this.variantZoneImages) return false;
    return Object.values(this.variantZoneImages).some((variantImages) => Boolean(variantImages?.[zoneKey]));
  }

  productUsesVariantZoneImages() {
    if (!this.variantZoneImages) return false;
    return Object.values(this.variantZoneImages).some((variantImages) =>
      Object.values(variantImages || {}).some(Boolean)
    );
  }

  getVariantZoneImageForCurrentSelection(zoneKey) {
    if (!zoneKey || !this.currentVariant?.id) return "";

    const selectedOptions = this.getDesiredSelections(this.currentVariant);
    const sizeIndexes = this.productOptions
      .map((option, index) => (this.isSizeOption(option.name) ? index : -1))
      .filter((index) => index >= 0);

    const candidates = this.productVariants.filter((variant) => {
      const variantId = String(variant?.id || "");
      if (!this.variantZoneImages?.[variantId]?.[zoneKey]) return false;
      return this.productOptions.every((option, index) => {
        if (sizeIndexes.includes(index)) return true;
        return this.getVariantOptionValue(variant, index) === selectedOptions[index];
      });
    });

    if (!candidates.length) return "";

    const preferredVariant =
      candidates.find((variant) => {
        return sizeIndexes.some((index) => {
          const value = String(this.getVariantOptionValue(variant, index) || "").trim().toLowerCase();
          return value === "s";
        });
      }) ||
      candidates.find((variant) => String(variant?.id || "") === String(this.currentVariant?.id || "")) ||
      candidates[0];

    return this.variantZoneImages?.[String(preferredVariant.id)]?.[zoneKey] || "";
  }

  getRelatedVariantPreferSizeS(variant, { requireZoneKey = "" } = {}) {
    if (!variant) return null;

    const selectedOptions = this.getDesiredSelections(variant);
    const sizeIndexes = this.productOptions
      .map((option, index) => (this.isSizeOption(option.name) ? index : -1))
      .filter((index) => index >= 0);

    const candidates = this.productVariants.filter((item) => {
      if (!item) return false;
      if (requireZoneKey) {
        const variantId = String(item?.id || "");
        if (!this.variantZoneImages?.[variantId]?.[requireZoneKey]) return false;
      } else if (!this.getVariantImageUrl(item)) {
        return false;
      }

      return this.productOptions.every((option, index) => {
        if (sizeIndexes.includes(index)) return true;
        return this.getVariantOptionValue(item, index) === selectedOptions[index];
      });
    });

    if (!candidates.length) return null;

    return (
      candidates.find((item) =>
        sizeIndexes.some((index) => String(this.getVariantOptionValue(item, index) || "").trim().toLowerCase() === "s")
      ) || candidates[0]
    );
  }

  getResolvedVariantImageUrl(variant) {
    if (this.productUsesVariantZoneImages()) {
      const colorPreviewImage = this.getCurrentColorPreviewImage();
      if (colorPreviewImage) return colorPreviewImage;
      const relatedVariant = this.getRelatedVariantPreferSizeS(variant);
      const relatedImage = this.getVariantImageUrl(relatedVariant);
      if (relatedImage) return relatedImage;
    }
    const directImage = this.getVariantImageUrl(variant);
    if (directImage) return directImage;
    const relatedVariant = this.getRelatedVariantPreferSizeS(variant);
    return this.getVariantImageUrl(relatedVariant) || "";
  }

  getZoneBaseImageUrl(zoneKey, fallbackImageUrl = "") {
    zoneKey = this.normalizeZoneKey(zoneKey);
    const currentVariantImageUrl = this.getResolvedVariantImageUrl(this.currentVariant);
    if (zoneKey && this.currentVariant?.id) {
      const variantZoneImage = this.getVariantZoneImageForCurrentSelection(zoneKey);
      if (variantZoneImage) return variantZoneImage;
      if (this.hasAnyVariantZoneImage(zoneKey)) {
        const colorPreviewImage = this.getCurrentColorPreviewImage();
        if (colorPreviewImage) return colorPreviewImage;
        const relatedVariant = this.getRelatedVariantPreferSizeS(this.currentVariant, { requireZoneKey: zoneKey }) || this.getRelatedVariantPreferSizeS(this.currentVariant);
        const relatedVariantImageUrl = this.getVariantImageUrl(relatedVariant);
        if (relatedVariantImageUrl) return relatedVariantImageUrl;
        if (currentVariantImageUrl) return currentVariantImageUrl;
      }
    }
    return fallbackImageUrl || currentVariantImageUrl || this.baseImageDefaultUrl;
  }

  refreshSelectedZoneImages() {
    for (const zone of this.zonesSelected.values()) {
      zone.imageBaseUrl = this.getZoneBaseImageUrl(zone.key, zone.fallbackImageUrl);
    }
  }

  toggleZoneSelection(item, button) {
    const exists = this.zonesSelected.has(item.label);
    if (exists) {
      this.zonesSelected.delete(item.label);
      if (this.currentZone === item.label) {
        const next = this.zonesSelected.keys().next().value || null;
        this.currentZone = next;
        this.selected = null;
      }
    } else {
      const zoneState = this.createZoneState(item);
      this.zonesSelected.set(item.label, zoneState);
      this.currentZone = item.label;
      this.selected = null;
    }
    this.syncZoneButtonsSelection();
    this.updateCurrentZoneArea();
    this.loadZoneImage();
    this.updateZoneTabs();
    this.updateEditorVisibility();
    this.loadZoneToInputs();
    this.syncHiddenFields();
    this.render();
    if (!exists) {
      this.openEditorOverlay();
    }
  }

  updateZoneTabs() {
    if (!this.tabsEl) return;
    const zones = Array.from(this.zonesSelected.values());
    this.tabsEl.innerHTML = "";
    if (zones.length === 0) {
      this.tabsEl.hidden = true;
      if (this.editorZonesTitleEl) this.editorZonesTitleEl.hidden = true;
      return;
    }
    this.tabsEl.hidden = false;
    if (this.editorZonesTitleEl) this.editorZonesTitleEl.hidden = false;
    zones.forEach((zone) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "product-customizer__zone-tab";
      btn.textContent = this.enablePriceIncrement ? zone.label : this.cleanZoneLabel(zone.label);
      if (zone.label === this.currentZone) btn.classList.add("is-active");
      btn.addEventListener("click", () => {
        this.currentZone = zone.label;
        this.selected = this.getZoneImageLayers(zone)[0]
          ? `image:${this.getZoneImageLayers(zone).at(-1).id}`
          : this.getZoneTextLayers(zone)[0]
            ? `text:${this.getZoneTextLayers(zone)[0].id}`
            : null;
        this.updateCurrentZoneArea();
        this.loadZoneImage();
        this.updateZoneTabs();
        this.updateEditorVisibility();
        this.loadZoneToInputs();
        this.render();
        this.openEditorOverlay();
      });
      this.tabsEl.appendChild(btn);
    });
  }

  updateEditorVisibility() {
    const hasType = !!this.state.type;
    const hasZone = this.zonesSelected.size > 0;
    const hasVisibleOptions = this.getSortedVisibleOptions().length > 0;
    const hasVisibleVariantPicker = this.showIntegratedVariantPicker && hasVisibleOptions;

    const shouldShow = (mode) => {
      if (mode === "hide") return false;
      if (mode === "start") return true;
      if (mode === "type") return hasType;
      return hasZone;
    };

    const typeField = this.typesContainer?.closest(".product-customizer__field") || null;
    let showTypeField = shouldShow(this.visibilityType);
    let showZoneField = shouldShow(this.visibilityZone);
    const showVinylField = shouldShow(this.visibilityVinyl);
    const showFlagField = shouldShow(this.visibilityFlag);
    const showNameField = shouldShow(this.visibilityName);
    const showNumberField = shouldShow(this.visibilityNumber);
    const showYearDadField = shouldShow(this.visibilityYearDad);
    const showYearBabyField = shouldShow(this.visibilityYearBaby);
    const showYearMomField = shouldShow(this.visibilityYearMom);
    const showPlayerNameField = shouldShow(this.visibilityPlayerName);
    const showDadNameField = shouldShow(this.visibilityDadName);
    const showMomNameField = shouldShow(this.visibilityMomName);
    const showChildNameField = shouldShow(this.visibilityChildName);
    const showDadNumberField = shouldShow(this.visibilityDadNumber);
    const showMomNumberField = shouldShow(this.visibilityMomNumber);
    const showChildNumberField = shouldShow(this.visibilityChildNumber);
    const showEditorField = shouldShow(this.visibilityEditor);

    if (!showTypeField && !hasVisibleVariantPicker && this.types.length) {
      showTypeField = true;
    }

    const anythingVisible =
      hasVisibleVariantPicker ||
      showTypeField ||
      showZoneField ||
      showVinylField ||
      showFlagField ||
      showNameField ||
      showNumberField ||
      showYearDadField ||
      showYearBabyField ||
      showYearMomField ||
      showPlayerNameField ||
      showDadNameField ||
      showMomNameField ||
      showChildNameField ||
      showDadNumberField ||
      showMomNumberField ||
      showChildNumberField ||
      showEditorField;

    if (!anythingVisible) {
      if (this.types.length) {
        showTypeField = true;
      } else {
        showZoneField = true;
      }
    }

    if (this.worldCupMode) {
      showTypeField = false;
    }

    if (typeField) typeField.hidden = !showTypeField;
    if (this.vinylFieldEl) this.vinylFieldEl.hidden = this.worldCupMode || !showVinylField;
    if (this.garmentFieldEl) this.garmentFieldEl.hidden = true;
    if (this.flagFieldEl) this.flagFieldEl.hidden = this.worldCupMode || !showFlagField;
    if (this.nameFieldEl) this.nameFieldEl.hidden = this.worldCupMode || !showNameField;
    if (this.numberFieldEl) this.numberFieldEl.hidden = this.worldCupMode || !showNumberField;
    if (this.yearDadFieldEl) this.yearDadFieldEl.hidden = this.worldCupMode || !showYearDadField;
    if (this.yearBabyFieldEl) this.yearBabyFieldEl.hidden = this.worldCupMode || !showYearBabyField;
    if (this.yearMomFieldEl) this.yearMomFieldEl.hidden = this.worldCupMode || !showYearMomField;
    if (this.playerNameFieldEl) this.playerNameFieldEl.hidden = this.worldCupMode || !showPlayerNameField;
    if (this.dadNameFieldEl) this.dadNameFieldEl.hidden = this.worldCupMode || !showDadNameField;
    if (this.momNameFieldEl) this.momNameFieldEl.hidden = this.worldCupMode || !showMomNameField;
    if (this.childNameFieldEl) this.childNameFieldEl.hidden = this.worldCupMode || !showChildNameField;
    if (this.dadNumberFieldEl) this.dadNumberFieldEl.hidden = this.worldCupMode || !showDadNumberField;
    if (this.momNumberFieldEl) this.momNumberFieldEl.hidden = this.worldCupMode || !showMomNumberField;
    if (this.childNumberFieldEl) this.childNumberFieldEl.hidden = this.worldCupMode || !showChildNumberField;
    if (this.editorEl) this.editorEl.hidden = !(showEditorField || showZoneField);
    if (this.editorOverlayEl) {
      if (!showEditorField && !showZoneField) this.closeEditorOverlay();
    }
    if (this.zoneFieldEl) this.zoneFieldEl.hidden = !showZoneField;
    if (this.variantPickerEl) this.variantPickerEl.hidden = !hasVisibleVariantPicker;
    if (this.openEditorBtn) this.openEditorBtn.hidden = !showZoneField;
    if (this.freeEditorEl) this.freeEditorEl.hidden = !!this.worldCupMode;
    if (this.worldCupEditorEl) this.worldCupEditorEl.hidden = !this.worldCupMode;
    if (!this.worldCupMode) {
      this.setElementVisibility(this.worldCupCountryFieldEl, false);
      this.setElementVisibility(this.worldCupNameFieldEl, false);
      this.setElementVisibility(this.worldCupNumberFieldEl, false);
    }
    this.updateImageLayersUI();
    this.updateTextLayersUI();
  }

  loadZoneToInputs() {
    const zone = this.getCurrentZoneState();
    if (!zone) {
      if (this.textInput) this.textInput.value = "";
      if (this.imageLayersEl) this.imageLayersEl.innerHTML = "";
      if (this.textLayersEl) this.textLayersEl.innerHTML = "";
      if (this.imageLayersSectionEl) this.imageLayersSectionEl.hidden = true;
      if (this.textLayersSectionEl) this.textLayersSectionEl.hidden = true;
      if (this.worldCupCountryInput) this.worldCupCountryInput.value = "";
      if (this.worldCupNameInput) this.worldCupNameInput.value = "";
      if (this.worldCupNumberInput) this.worldCupNumberInput.value = "";
      this.setElementVisibility(this.worldCupCountryFieldEl, false);
      this.setElementVisibility(this.worldCupNameFieldEl, false);
      this.setElementVisibility(this.worldCupNumberFieldEl, false);
      return;
    }
    const visibility = this.getWorldCupVisibility(zone.key);
    this.setElementVisibility(this.worldCupCountryFieldEl, this.worldCupMode && visibility.country);
    this.setElementVisibility(this.worldCupNameFieldEl, this.worldCupMode && visibility.name);
    this.setElementVisibility(this.worldCupNumberFieldEl, this.worldCupMode && visibility.number);
    if (this.worldCupCountryInput) this.worldCupCountryInput.value = zone.worldCup?.country || "";
    if (this.worldCupNameInput) this.worldCupNameInput.value = zone.worldCup?.name || "";
    if (this.worldCupNumberInput) this.worldCupNumberInput.value = zone.worldCup?.number || "";
    const layer = this.getSelectedTextLayer(zone) || this.getZoneTextLayers(zone)[0] || null;
    if (this.textInput) this.textInput.value = layer?.value || "";
    if (this.textFontInput) this.textFontInput.value = layer?.font || this.state.textFont || this.textFontInput.value;
    if (this.textSizeInput) this.textSizeInput.value = layer?.size || this.state.textSize || 28;
    if (this.textColorInput) this.textColorInput.value = layer?.color || this.state.textColor || "#111111";
    if (this.textColorHexInput) this.textColorHexInput.value = (layer?.color || this.state.textColor || "#111111").toUpperCase();
    if (layer) {
      this.state.textFont = layer.font || this.state.textFont;
      this.state.textSize = layer.size || this.state.textSize;
      this.state.textColor = layer.color || this.state.textColor;
    }
    this.updateImageLayersUI();
    this.updateTextLayersUI();
  }

  updateCurrentZoneArea() {
    const zone = this.getCurrentZoneState();
    if (!zone) {
      this.state.zoneArea = null;
      return;
    }
    if (this.forceFullZone) {
      this.state.zoneArea = { x: 0, y: 0, w: 1, h: 1 };
      return;
    }
    this.state.zoneArea = this.parseArea(zone.area);
  }

  getZoneAreaForZone(zone) {
    if (!zone) return null;
    if (this.forceFullZone) return { x: 0, y: 0, w: 1, h: 1 };
    return this.parseArea(zone.area);
  }

  loadZoneImage() {
    const zone = this.getCurrentZoneState();
    if (!zone) return;
    zone.imageBaseUrl = this.getZoneBaseImageUrl(zone.key, zone.fallbackImageUrl);
    const url = zone.imageBaseUrl || this.baseImageDefaultUrl;
    this.setBaseImage(url);
  }

  getBaseImageForZone(zone) {
    if (!zone) return this.baseImage;
    const url = this.getZoneBaseImageUrl(zone.key, zone.fallbackImageUrl) || this.baseImageDefaultUrl;
    return this.baseImageCache.get(url) || this.baseImage;
  }

  bindVariantSync() {
    const target = this.form || document;
    target.addEventListener("variant:change", (event) => {
      this.applyVariantState(event?.detail?.variant || null);
    });
  }

  applyVariantState(variant) {
    this.currentVariant = variant || this.currentVariant || null;

    const nextBaseImageUrl = this.getResolvedVariantImageUrl(this.currentVariant) || this.initialBaseImageUrl;
    if (nextBaseImageUrl) {
      this.baseImageDefaultUrl = nextBaseImageUrl;
      if (!this.getCurrentZoneState()) {
        this.setBaseImage(nextBaseImageUrl);
      } else {
        this.loadZoneImage();
      }
    }

    if (this.syncGarmentColorFromVariant) {
      this.state.garmentColor = this.getGarmentColorFromVariant(this.currentVariant);
    }

    this.refreshSelectedZoneImages();

    this.syncVariantIdInputs(this.currentVariant);
    this.syncHiddenFields();
    this.renderVariantPicker();
    this.updateEditorVisibility();
    this.render();
  }

  getVariantImageUrl(variant) {
    if (!variant) return "";
    if (variant.featured_image?.src) return variant.featured_image.src;
    if (variant.featured_media?.preview_image?.src) return variant.featured_media.preview_image.src;
    if (variant.image?.src) return variant.image.src;
    if (typeof variant.image === "string") return variant.image;
    return "";
  }

  getVariantOptionValue(variant, index) {
    if (!variant || index < 0) return "";
    if (Array.isArray(variant.options) && typeof variant.options[index] === "string") {
      return variant.options[index];
    }
    const key = `option${index + 1}`;
    return typeof variant[key] === "string" ? variant[key] : "";
  }

  getVariantLabel(variant) {
    if (!variant) return "";
    if (variant.title && variant.title !== "Default Title") return variant.title;
    if (Array.isArray(variant.options)) return variant.options.filter(Boolean).join(" / ");
    return "";
  }

  getGarmentColorFromVariant(variant) {
    if (!variant) return "";
    const directColor = this.getVariantOptionValue(variant, this.colorOptionIndex);
    if (directColor) return directColor;
    if (Array.isArray(variant.options) && variant.options.length) {
      return variant.options.join(" / ");
    }
    return this.getVariantLabel(variant);
  }

  getSelectedOptionsMap(variant) {
    if (!variant) return {};
    const map = {};
    const options = Array.isArray(variant.options) ? variant.options : [];
    options.forEach((value, index) => {
      map[index] = value;
    });
    return map;
  }

  getActivePickerSelections() {
    const map = {};
    if (!this.variantPickerEl) return map;
    this.variantPickerEl.querySelectorAll("[data-option-index].is-active").forEach((button) => {
      const optionIndex = Number(button.dataset.optionIndex);
      if (Number.isNaN(optionIndex)) return;
      map[optionIndex] = button.dataset.value || button.textContent?.trim() || "";
    });
    return map;
  }

  getDesiredSelections(variant) {
    return {
      ...this.getSelectedOptionsMap(variant),
      ...this.getActivePickerSelections()
    };
  }

  getCurrentColorPreviewImage() {
    const activeColorButtonImage = this.variantPickerEl?.querySelector(".product-customizer__variant-color.is-active img");
    if (activeColorButtonImage?.src) return activeColorButtonImage.src;

    if (this.colorOptionIndex < 0) return "";
    const desiredSelections = this.getDesiredSelections(this.currentVariant);
    const currentColorValue = desiredSelections[this.colorOptionIndex];
    if (!currentColorValue) return "";
    return this.getOptionValuePreviewImage(this.colorOptionIndex, currentColorValue) || "";
  }

  isColorOption(optionName) {
    const normalized = String(optionName || "").toLowerCase();
    return normalized.includes("color") || normalized.includes("colour");
  }

  isSleeveOption(optionName) {
    const normalized = String(optionName || "").toLowerCase();
    return normalized.includes("manga") || normalized.includes("sleeve");
  }

  isSizeOption(optionName) {
    const normalized = String(optionName || "").toLowerCase();
    return normalized.includes("talla") || normalized.includes("size");
  }

  normalizeOptionName(optionName) {
    return String(optionName || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }

  getBaseOptionKind(kind) {
    return kind;
  }

  getOptionConfig(kind) {
    const baseKind = this.getBaseOptionKind(kind);
    return {
      visibility: this.variantOptionVisibility[baseKind] !== false,
      mode: this.variantOptionVisibilityMode[baseKind] || "start",
      order: baseKind === "other" ? 99 : this.variantOptionOrder[baseKind]
    };
  }

  getOptionDisplayName(optionName) {
    const normalized = this.normalizeOptionName(optionName);
    const kind = this.getOptionKind(optionName);
    if (this.variantLabels[kind]) return this.variantLabels[kind];
    if (normalized === "manga" || normalized === "sleeve") return this.variantLabels.manga;
    if (normalized === "color" || normalized === "colour") return this.variantLabels.color;
    if (normalized === "talla" || normalized === "size") return this.variantLabels.talla;
    return optionName;
  }

  getOptionKind(optionName) {
    const normalized = this.normalizeOptionName(optionName);
    if (this.isSleeveOption(optionName)) return "manga";
    if (this.isColorOption(optionName)) return "color";
    if (normalized.includes("talla papa")) return "talla_papa";
    if (normalized.includes("talla mama")) return "talla_mama";
    if (normalized.includes("talla bebe")) return "talla_bebe";
    if (normalized.includes("talla nino") || normalized.includes("talla niño")) return "talla_nino";
    if (this.isSizeOption(optionName)) return "talla";
    return "other";
  }

  getSortedVisibleOptions() {
    return this.productOptions
      .map((option, optionIndex) => ({ option, optionIndex, kind: this.getOptionKind(option.name) }))
      .filter(({ kind }) => {
        const config = this.getOptionConfig(kind);
        return config.visibility && this.shouldShowMode(config.mode);
      })
      .sort((a, b) => {
        const aOrder = this.getOptionConfig(a.kind).order;
        const bOrder = this.getOptionConfig(b.kind).order;
        if (aOrder !== bOrder) return aOrder - bOrder;
        return a.optionIndex - b.optionIndex;
      });
  }

  hasSelectedVariantOption(kind) {
    const currentSelections = this.getSelectedOptionsMap(this.currentVariant || this.productVariants[0]);
    const optionEntries = this.productOptions
      .map((option, optionIndex) => ({ option, optionIndex, kind: this.getOptionKind(option.name) }))
      .filter((entry) => entry.kind === kind);

    if (!optionEntries.length) return true;
    return optionEntries.every((entry) => Boolean(currentSelections[entry.optionIndex]));
  }

  getOptionValueState(optionIndex, value, selectedOptions) {
    const candidateSelections = { ...selectedOptions, [optionIndex]: value };
    const matches = this.productVariants.filter((variant) => this.variantMatchesSelections(variant, candidateSelections));
    const availableMatch = matches.find((variant) => variant.available);
    return {
      available: Boolean(availableMatch),
      selected: selectedOptions[optionIndex] === value
    };
  }

  getOptionValuePreviewImage(optionIndex, value) {
    const selectedOptions = this.getSelectedOptionsMap(this.currentVariant || this.productVariants[0]);
    const candidateSelections = { ...selectedOptions, [optionIndex]: value };
    const matchingVariants = this.productVariants.filter((item) => this.variantMatchesSelections(item, candidateSelections));

    const variant =
      matchingVariants.find((item) => item.available && this.getVariantImageUrl(item)) ||
      matchingVariants.find((item) => this.getVariantImageUrl(item)) ||
      matchingVariants.find((item) => item.available) ||
      matchingVariants[0] ||
      this.productVariants.find((item) => {
        const options = Array.isArray(item.options) ? item.options : [];
        return options[optionIndex] === value && this.getVariantImageUrl(item);
      }) ||
      this.productVariants.find((item) => {
        const options = Array.isArray(item.options) ? item.options : [];
        return options[optionIndex] === value;
      });

    return this.getVariantImageUrl(variant);
  }

  selectVariantOption(optionIndex, value) {
    const selectedOptions = {
      ...this.getSelectedOptionsMap(this.currentVariant || this.productVariants[0]),
      [optionIndex]: value
    };

    let variant = this.findExactVariant(selectedOptions);
    if (!variant || !variant.available) {
      variant = this.findClosestAvailableVariant(selectedOptions);
    }
    if (!variant) return;

    this.applyVariantState(variant);
    this.requestThemeVariantUpdate(variant, optionIndex, value);
  }

  findExactVariant(selectedOptions) {
    return this.productVariants.find((variant) => this.variantExactlyMatchesSelections(variant, selectedOptions)) || null;
  }

  findClosestAvailableVariant(selectedOptions) {
    return this.productVariants.find((variant) => variant.available && this.variantMatchesSelections(variant, selectedOptions)) || null;
  }

  variantMatchesSelections(variant, selectedOptions) {
    const options = Array.isArray(variant.options) ? variant.options : [];
    return Object.entries(selectedOptions).every(([index, value]) => {
      if (!value) return true;
      return options[Number(index)] === value;
    });
  }

  variantExactlyMatchesSelections(variant, selectedOptions) {
    const options = Array.isArray(variant.options) ? variant.options : [];
    return this.productOptions.every((_, index) => options[index] === selectedOptions[index]);
  }

  syncVariantIdInputs(variant) {
    if (!this.form || !variant?.id) return;
    const allIdInputs = Array.from(this.form.querySelectorAll('input[name="id"]'));
    allIdInputs.forEach((input) => {
      input.value = variant.id;
      input.disabled = false;
    });
  }

  requestThemeVariantUpdate(variant, optionIndex, value) {
    const productInfo = this.root.closest("product-info");
    const fallbackTarget = this.form || document;

    if (!productInfo) {
      fallbackTarget.dispatchEvent(new CustomEvent("variant:change", { detail: { variant } }));
      return;
    }

    const productUrl = productInfo.getAttribute("data-product-url") || window.location.pathname;
    const requestUrl = `${productUrl}?section_id=${productInfo.sectionId}&variant=${variant.id}`;
    const targetId = `customizer-variant-${this.formId}-${optionIndex}-${this.safeSlug(value)}`;

    if (typeof productInfo.renderProductInfo === "function" && typeof productInfo.handleUpdateProductInfo === "function") {
      productInfo.renderProductInfo({
        requestUrl,
        targetId,
        callback: productInfo.handleUpdateProductInfo()
      });
      return;
    }

    fallbackTarget.dispatchEvent(new CustomEvent("variant:change", { detail: { variant } }));
  }

  setBaseImage(url) {
    if (!url) return;
    if (this.baseImageUrl === url && this.baseImage) {
      this.render();
      return;
    }
    this.baseImageUrl = url;
    const cached = this.baseImageCache.get(url);
    if (cached) {
      this.baseImage = cached;
      this.render();
      return;
    }
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      this.baseImage = img;
      this.baseImageCache.set(url, img);
      this.render();
    };
    img.src = url;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-customizer]").forEach((el) => {
    new ProductCustomizer(el);
  });
});
